import React, { useState, useEffect, useRef, useCallback } from "react";
import isEqual from "lodash/isEqual";
import toast from "react-hot-toast";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import RichTextEditor from "../../../../Components/Editor/RichTextEditor";
import AddFormModal from "../../../../Components/Modal/supplier_app/AddFormModal";

import { useNavigate, useLocation } from "react-router-dom";

import Loader from "../../../../Components/Loader";

//Redux
import { useSelector, useDispatch } from "react-redux"; //useDispatch

//Serivce
import ItemService from "../../../../services/supplier_appCommonService";

//Components
import Layout from "../../../../Layout/Layout";
import { InputField } from "../../../../Components/formElements/InputField";
import { ComboboxField } from "../../../../Components/formElements/ComboboxField";
// import SourcingCommonFilter from "../../../Components/Filter/Sourcing/SourcingCommonFilter";
import DataTable from "react-data-table-component";
import CreateRFQSuppliers from "../../../../Components/Modal/supplier_app/Sourcing/CreateRFQSuppliers";
import { TextAreaField } from "../../../../Components/formElements/TextAreaField";
import {
  checkTimeDifference,
  formatDate,
  isValidNumber,
} from "../../../../common/Validations";
import SuccessRegisterModal from "../../../../Components/SuccessRegisterModal";
import Constants from "../../../../common/SupplierConstants";
import { MultiselectField } from "../../../../Components/formElements/MultiselectField";
import {
  addDynamicFormDataCOMM,
  addDynamicFormDataTECH,
  updateQuestionCriteria,
  // getRfqQuotation,
} from "../../../../redux/feature/supplier_app/sourcingSlice";
import FailureModal from "../../../../Components/Modal/supplier_app/FailureModal";
import CommonItemLevelDatatableModal from "../../../../Components/Modal/supplier_app/CommonItemLevelDatatableModal";
import { TableStatusField } from "../../../../Components/formElements/TableStatusField";
import FileUploadComponent from "../../../../Components/formElements/FileUploadComponent";
import FileUploadComponentForHB from "../../../../Components/formElements/FileUploadComponentForHB";
import FileViewerModal from "../../../../Components/FileViewer/FileViewerModal";
import FileViewerModalForHB from "../../../../Components/FileViewer/FileViewerModalForHB";
import { getDeliveryAddressOptions } from "../PR/PRConstant";

// Stable no-op for ComboboxField's getvalue. ComboboxField's default getvalue
// is a fresh arrow each render (a default parameter), which is an unstable
// dependency for its effect and causes an infinite render loop. A module-level
// constant reference never changes.
const NOOP = () => {};

// Stable options for the per-question "Criteria" dropdown. Declared at module
// level (not inside RenderInputField) so the array and each option object keep
// the same identity across renders — ComboboxField runs an effect keyed on the
// props it receives, so a freshly-built array / option object each render would
// keep re-firing that effect.
const criteriaOptions = [
  { id: "Weighted", name: "Weighted" },
  { id: "Unweighted", name: "Unweighted" },
];

// Default per-questionnaire weightage budgets. The Commercial and Technical
// questionnaires are each scored out of 100 internally, so the sum of a block's
// question weightages must not exceed these. This is independent of the
// Commercial/Technical Total split (e.g. 40/60) set in the Basic Information
// block — that split decides how the two sections combine, these caps bound the
// question weightages within each section.
const defaultCommercialTotalWeigtage = 100;
const defaultTechnicalTotalWeight = 100;

// Ordered wizard steps. The header tabs, tab panels and the footer
// Previous / Next / Create RFQ buttons all key off this single list so the
// order stays in sync. Create RFQ is only shown on the final step.
const tabList = [
  { id: "rqf-titlle", label: "RFQ Title" },
  { id: "configuration", label: "Configuration" },
  { id: "addItems", label: "Add Items" },
  { id: "technicalCommercial", label: "Tech & Comm Template" },
  { id: "addSuppliers", label: "Add Suppliers" },
  { id: "schedule", label: "Schedule" },
];

// Questionnaire answer field rendered per question.
// Declared at MODULE level (not inside the component) and wrapped in React.memo
// so its function/type reference is stable. A component defined inside the
// parent is a NEW type each render, which makes React unmount/remount every
// input on each keystroke — causing the "only one letter types, then it drops
// out of scope" bug and reset dropdowns.
// Props: questionData, formKey, formAnswers, onChangeAnswer, onChangeCriteriaWeightage
const RenderInputField = React.memo(
  ({
    questionData,
    formKey,
    formAnswers,
    onChangeAnswer,
    onChangeCriteriaWeightage,
    onViewAttachment,
    weightageCap = 0,
    otherWeightageTotal = 0,
  }) => {
    const {
      componentId,
      mandatory,
      question,
      answerDefinition,
      serialNo,
      criteria,
      weightage,
      weightageStatus,
    } = questionData;
    const answerValue = formAnswers?.[`${formKey}-${componentId}`];
    // Attachment id for this question, kept in the shared formAnswers map under a
    // `-attachment` suffixed key so it never collides with the question's answer.
    const attachmentValue =
      formAnswers?.[`${formKey}-${componentId}-attachment`];

    const setAnswer = (componentId2, value) =>
      onChangeAnswer(formKey, componentId2, value);

    // Local state for criteria and weightage to allow editing in the UI
    const [localCriteria, setLocalCriteria] = React.useState(
      criteria || "Weighted",
    );
    const [localWeightage, setLocalWeightage] = React.useState(weightage || 0);
    const [localWeightageStatus, setLocalWeightageStatus] = React.useState(
      weightageStatus || false,
    );

    // handleCriteriaChange is passed to ComboboxField as its `getvalue` prop,
    // and ComboboxField calls that prop from an effect keyed on it (and on
    // mount). It must therefore be a STABLE reference: a fresh arrow each render
    // re-fires the effect on every render, which dispatches to Redux, which
    // re-renders the parent → "Maximum update depth exceeded". localWeightage is
    // a dependency because the payload reports the current weightage while
    // criteria is Weighted; that only changes this identity when the weightage
    // input itself changes (bounded), never on every render.
    const handleCriteriaChange = React.useCallback(
      (selectedOption) => {
        const newCriteria = selectedOption?.id || "Weighted";
        setLocalCriteria(newCriteria);
        if (newCriteria === "Unweighted") {
          setLocalWeightage(0);
          setLocalWeightageStatus(true);
        } else {
          setLocalWeightageStatus(false);
        }
        // Notify parent to update Redux
        if (onChangeCriteriaWeightage) {
          onChangeCriteriaWeightage(formKey, componentId, {
            criteria: newCriteria,
            weightage: newCriteria === "Unweighted" ? 0 : localWeightage,
            weightageStatus: newCriteria === "Unweighted",
          });
        }
      },
      [formKey, componentId, onChangeCriteriaWeightage, localWeightage],
    );

    const handleWeightageChange = (e) => {
      const value = parseInt(e.target.value) || 0;
      const cap = Number(weightageCap) || 0;
      // Block entry that would push the block's total weightage above the cap
      // set in the Basic Information block (Total Weightage Value).
      if (cap > 0 && (Number(otherWeightageTotal) || 0) + value > cap) {
        toast.error(`Total weightage cannot exceed ${cap}`, {
          id: `weightage-cap-${formKey}`,
          duration: 3000,
          position: "top-right",
        });
        return;
      }
      setLocalWeightage(value);
      if (onChangeCriteriaWeightage) {
        onChangeCriteriaWeightage(formKey, componentId, {
          criteria: localCriteria,
          weightage: value,
          weightageStatus: localWeightageStatus,
        });
      }
    };

    const renderCriteriaWeightage = () => (
      <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
        <Row>
          <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
            <ComboboxField
              label="Criteria"
              placeholder="Select Criteria"
              data={criteriaOptions}
              id={`criteria-${componentId}`}
              name={`criteria-${componentId}`}
              code="id"
              description="name"
              setValue={
                criteriaOptions.find((opt) => opt.id === localCriteria) ||
                criteriaOptions[0]
              }
              getvalue={handleCriteriaChange}
              required={true}
            />
          </Col>
          <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
            <InputField
              type="number"
              className="inputBox"
              label="Weightage"
              placeholder="Enter weightage"
              value={localWeightage}
              onChange={handleWeightageChange}
              disabled={localWeightageStatus}
            />
          </Col>
        </Row>
      </Col>
    );

    // Required attachment rendered under each question (after Criteria/Weightage).
    // Full-width (md=12) so each question still spans an exact number of grid
    // rows and questions stay aligned in the shared Row. The uploaded
    // attachmentId is stored back into formAnswers via setAnswer.
    const renderAttachment = () =>
      // Attachment upload + view image hidden in the UI per request.
      // Code kept intact via `false &&` so it can be re-enabled later.
      false && (
        <Col xs={12} md={12} lg={12} className="commTopButtonRightLeftPadding">
          <FileUploadComponentForHB
            id={`${componentId}-attachment`}
            name={`${componentId}-attachment`}
            label="Attachment"
            allowedTypes={["image/png", "image/jpeg", "application/pdf"]}
            multiple={true}
            required={false}
            value={attachmentValue || ""}
            onSuccessUpload={(data) =>
              setAnswer(`${componentId}-attachment`, data?.attachmentId)
            }
          />
          {attachmentValue && (
            <img
              src="assets/img/newIcons/attached-file.png"
              className="mt-1 attachmentIcon"
              alt="attachments"
              onClick={() =>
                onViewAttachment &&
                onViewAttachment(formKey, componentId, attachmentValue)
              }
            />
          )}
        </Col>
      );

    switch (answerDefinition?.type) {
      case "textarea":
        return (
          <React.Fragment>
            <Col xs={12} md={6} lg={6} className="commLeftRightPadding">
              <TextAreaField
                label={serialNo + ". " + question?.label}
                id={componentId}
                name={componentId}
                className="inputBox"
                placeholder=""
                value={answerValue || ""}
                onChange={(e) => setAnswer(componentId, e.target.value)}
                required={mandatory}
              />
            </Col>
            {renderCriteriaWeightage()}
            {renderAttachment()}
          </React.Fragment>
        );
      case "select":
        // Match the stored answer back to its option so the ComboboxField can
        // display the selected label (it renders value via the option object).
        const selectedOption =
          (answerDefinition?.options || []).find(
            (o) =>
              o?.name === answerValue ||
              o?.value === answerValue ||
              String(o?.id) === String(answerValue),
          ) || null;
        return (
          <React.Fragment>
            <Col
              xs={12}
              md={6}
              lg={6}
              className="commTopButtonRightLeftPadding"
            >
              <ComboboxField
                label={serialNo + ". " + question?.label}
                placeholder=""
                data={answerDefinition?.options}
                id={componentId}
                iconClassName="dropdownIcon"
                name={componentId}
                code={componentId}
                description="name"
                setValue={selectedOption}
                required={mandatory}
                // getvalue must be a STABLE reference: ComboboxField's getvalue
                // default is a fresh arrow each render, so omitting it (or passing
                // an inline one) makes its effect loop. Pass the stable NOOP.
                getvalue={NOOP}
                onChangeValue={(idx, cid, val) => setAnswer(cid, val)}
              />
            </Col>
            {renderCriteriaWeightage()}
            {renderAttachment()}
          </React.Fragment>
        );
      case "radio":
        return (
          <React.Fragment>
            <Col
              xs={12}
              md={6}
              lg={6}
              className="commTopButtonRightLeftPadding"
            >
              <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
                {serialNo + ". " + question?.label} {mandatory && "*"}
              </label>

              {answerDefinition?.options.map((option, index) => (
                <div key={index} className="block">
                  <input
                    type="radio"
                    className="form-check-input fs-5 ml-3"
                    id={`${componentId}-${index}`}
                    name={componentId}
                    value={option?.value ?? option?.name ?? ""}
                    checked={answerValue === (option?.value ?? option?.name)}
                    onChange={(e) => setAnswer(componentId, e.target.value)}
                    required={mandatory}
                  />
                  <span className="ml-3">{option?.value} </span>
                </div>
              ))}
            </Col>
            {renderCriteriaWeightage()}
            {renderAttachment()}
          </React.Fragment>
        );
      case "checkbox":
        return (
          <React.Fragment>
            <Col
              xs={12}
              md={6}
              lg={6}
              className="commTopButtonRightLeftPadding"
            >
              <label className="block text-sm font-medium leading-6 text-gray-900 infoIconAccordion w-100">
                {serialNo + ". " + question?.label} {mandatory && "*"}
              </label>

              {answerDefinition?.options.map((option, index) => {
                const optVal = option?.value ?? option?.name ?? "";
                const isChecked =
                  Array.isArray(answerValue) && answerValue.includes(optVal);
                return (
                  <div key={index} className="block">
                    <input
                      type="checkbox"
                      className="form-check-input fs-5 ml-3"
                      id={`${componentId}-${index}`}
                      name={componentId}
                      value={optVal}
                      checked={isChecked}
                      onChange={(e) => {
                        const current = Array.isArray(answerValue)
                          ? answerValue
                          : [];
                        const next = e.target.checked
                          ? [...current, optVal]
                          : current.filter((v) => v !== optVal);
                        setAnswer(componentId, next);
                      }}
                      required={mandatory}
                    />
                    <span className="ml-3">{optVal} </span>
                  </div>
                );
              })}
            </Col>
            {renderCriteriaWeightage()}
            {renderAttachment()}
          </React.Fragment>
        );
      case "text":
        return (
          <React.Fragment>
            <Col
              xs={12}
              md={6}
              lg={6}
              className="commTopButtonRightLeftPadding block"
            >
              <InputField
                label={serialNo + ". " + question?.label}
                type="text"
                className="inputBox"
                id={componentId}
                name={componentId}
                placeholder=""
                value={answerValue || ""}
                onChange={(e) => setAnswer(componentId, e.target.value)}
                required={mandatory}
              />
            </Col>
            {renderCriteriaWeightage()}
            {renderAttachment()}
          </React.Fragment>
        );
      case "number":
        return (
          <React.Fragment>
            <Col
              xs={12}
              md={6}
              lg={6}
              className="commTopButtonRightLeftPadding block"
            >
              <InputField
                label={serialNo + ". " + question?.label}
                type="number"
                className="inputBox"
                id={componentId}
                name={componentId}
                placeholder=""
                value={answerValue || ""}
                onChange={(e) => setAnswer(componentId, e.target.value)}
                required={mandatory}
              />
            </Col>
            {renderCriteriaWeightage()}
            {renderAttachment()}
          </React.Fragment>
        );
      default:
        return "";
    }
  },
);

const CreateRFQTabs = () => {
  const dispatch = useDispatch();

  const navigate = useNavigate();
  const location = useLocation();
  const { draftId: draftIdParam, newDraft: newDraftParam } =
    location.state || {};

  const previousFullDataRef = useRef(null);
  const isFirstAutoSave = useRef(true);
  const draftDataRef = useRef(null);

  let rfxCategoryType = useSelector((state) => state?.sourcing.purchaseDocType);
  let rfxCategoryCode = useSelector((state) => state?.sourcing.purchaseDocCode);
  // let purchaseTypeCode = useSelector((state) => state?.sourcing.purchaseDocCode);
  let purchaseTypeCode = useSelector(
    (state) => state?.sourcing.purchaseTypeCode,
  );

  let rfxCategoryDescription = useSelector(
    (state) => state?.sourcing.purchaseDocDescription,
  );
  let rfqCreation = useSelector((state) => state?.sourcing.rfqCreation);
  let approvedSelectedRows = useSelector(
    (state) => state?.sourcing.purchase_requisition.approvedSelectedRows,
  );
  let userData = useSelector((state) => state?.user?.data); // User Details from Store

  // let dynamicFormDataStatus = useSelector(
  //   (state) => state?.sourcing?.purchase_requisition?.dynamicFormDataStatus
  // ); // purchase_requisition from Store
  let dynamicFormDataCOMM = useSelector(
    (state) => state?.sourcing?.purchase_requisition?.dynamicFormDataCOMM,
  ); // purchase_requisition from Store
  let dynamicFormDataTECH = useSelector(
    (state) => state?.sourcing?.purchase_requisition?.dynamicFormDataTECH,
  ); // purchase_requisition from Store

  // Sum of the per-question weightages entered in each questionnaire block.
  // Shown at the top of the block and used to cap entry against the Total
  // Weightage Value from the Basic Information block.
  const technicalWeightSum = (dynamicFormDataTECH || []).reduce(
    (sum, q) => sum + (Number(q?.weightage) || 0),
    0,
  );
  const commercialWeightSum = (dynamicFormDataCOMM || []).reduce(
    (sum, q) => sum + (Number(q?.weightage) || 0),
    0,
  );

  // let dropdownOption = [
  //   {
  //     id: "1",
  //     name: "Sample Data 1",
  //   },
  //   {
  //     id: "2",
  //     name: "Sample Data 2",
  //   },
  // ];
  let reminderDropDown = [
    {
      id: "1",
      name: "Yes",
    },
    {
      id: "2",
      name: "No",
    },
  ];

  // const [getDynamicFormDataCOMM, setDynamicFormDataCOMM] = useState(true);
  // const [getDynamicFormDataTECH, setDynamicFormDataTECH] = useState(true);

  const [isCardVisible, setCardVisible] = useState(true);
  const [isCardVisible2, setCardVisible2] = useState(true);
  const [isCardVisible3, setCardVisible3] = useState(true);
  const [isCardVisible5, setCardVisible5] = useState(true);
  const [isCardVisible6, setCardVisible6] = useState(true);
  const [isCardVisible7, setCardVisible7] = useState(true);
  const [isCardVisible8, setCardVisible8] = useState(true);
  // const [isCardVisible8_1, setCardVisible8_1] = useState(true);
  const [isCardVisible9, setCardVisible9] = useState(true);
  // const [isCardVisible9_1, setCardVisible9_1] = useState(true);
  const [isCardVisible10, setCardVisible10] = useState(true);
  // const [getAccessData, setAccessData] = useState("");

  const [disabled, setDisabled] = useState(false);
  const [getDropdownData, setDropdownData] = useState("");
  // Dedicated RFQ Type selection. Kept separate from getDropdownData because
  // every ComboboxField in this form writes to setDropdownData — a later field
  // (bid type, currency, etc.) would otherwise overwrite the RFQ type and hide
  // the Technical/Commercial questionnaire blocks.
  const [rfqTypeSelection, setRfqTypeSelection] = useState(null);
  // Questionnaire answers keyed by componentId (shared by TECH and COMM forms,
  // since componentIds like "question_1" are distinct within each list but the
  // two lists are submitted separately). Keyed by `${formKey}-${componentId}`
  // to avoid any collision between TECH and COMM.
  const [formAnswers, setFormAnswers] = useState({});
  // Tabs (keyed by tab-pane id) that currently contain a validation error, so
  // the tab header can be highlighted red. Recomputed on each Create RFQ click.
  const [tabErrors, setTabErrors] = useState({});
  // Currently active tab id — controls which tab-pane is visible.
  const [activeTab, setActiveTab] = useState("rqf-titlle");
  const [editorContent, setEditorContent] = useState("");
  const [getpaymentTerm, setpaymentTerm] = useState([]);
  const [getRFxType, setRFxType] = useState([]);
  const [getRFxProductType, setRFxProductType] = useState([]);
  const [getRfxPurchaseType, setRfxPurchaseType] = useState([]);
  const [getRfxBidType, setRfxBidType] = useState([]);
  const [getCompanyAddress, setCompanyAddress] = useState([]);
  const [getBillingAddress, setBillingAddress] = useState([]);
  // eslint-disable-next-line
  const [getDeliveryAddress, setDeliveryAddress] = useState([]);
  const [getINCOTerms, setINCOTerms] = useState([]);
  const [getcurrency, setcurrency] = useState([]);
  const [getTechnicalApprovalType, setTechnicalApprovalType] = useState([]);
  const [getRfxNoOfEvaluationType, setRfxNoOfEvaluationType] = useState([]);
  const [getPlant, setPlant] = useState([]);
  const [getLineItemData, setLineItemData] = useState([]);
  const [getCreateDynamicformModelShow, setCreateDynamicformModelShow] =
    useState(false);
  const [getFormModalData, setFormModalData] = useState({});

  const [getTechnicalUserList, setTechnicalUserList] = useState([]);

  // Other Charges state
  const [getChargesSelcetion, setChargesSelcetion] = useState([]);
  const [getChargesSelected, setChargesSelected] = useState([]);
  const [getOtherChargesValue, setOtherChargesValue] = useState(0);
  const [subTotalValue, setSubTotalValue] = useState(0);
  const [isCardVisibleCS, setCardVisibleCS] = useState(true);

  const [draftData, setDraftData] = useState(null);
  const [isLoadingDraft, setIsLoadingDraft] = useState(true);
  const previousSavedStateRef = useRef(null);

  const getFullFormData = () => {
    const base = {
      // Spread all simple fields from formInputs
      ...formInputs,
      // Nested/complex fields
      lineItems: rfqCreation === "PR" ? getLineItemData : getPRLineItemsData,
      supplierList: getSupplierData,
      termsConditions: termsConditionsData,
      instructions: editorContent,
      formCOMM: dynamicFormDataCOMM,
      formTECH: dynamicFormDataTECH,
      otherCharges: getChargesSelected,
      // Open/close and totals
      openingDateTime:
        getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime,
      closingDateTime:
        getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime,
      totalHour: getOpenCloseInput.totalHour,
      openingDate: getOpenCloseInput.openingDate,
      openingTime: getOpenCloseInput.openingTime,
      closingDate: getOpenCloseInput.closingDate,
      closingTime: getOpenCloseInput.closingTime,
      qtnSubTotalLineItem: subTotalValue,
      qtnSubTotalOtherCharges: getOtherChargesValue,
      qtnTotal: (subTotalValue || 0) + (getOtherChargesValue || 0),
    };

    const progress = calculateDraftProgress(base);
    return { ...base, completionPercentage: progress };
  };

  const createEmptyFormData = () => ({
    rfxType: "",
    productType: purchaseTypeCode || "",
    rfxValue: "",
    rfxHeaderStatus: "RFQ Created",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    buyerResponsible: "",
    companyAddress: "",
    billingAddress: "",
    rfxVersion: "V0",
    buyerEmail: userData?.email || "",
    initiatorName: userData?.firstName || "",
    initiator: userData?.userId || "",
    createdOn: "",
    buyerConact: userData?.contactNumber || "",
    deliveryAddressCodeDesc: "",
    rfxCategoryType: rfxCategoryType || "",
    rfxCategoryCode: rfxCategoryCode || "",
    rfxCategoryDesc: rfxCategoryDescription || "",
    rfqCreation: rfqCreation || "",
    rfxTitle: "",
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    rfxDescription: "",
    typeOfPurchase: "",
    otherCurrencies: [],
    headerIncoTerms: "",
    INCOTerms: "",
    incoTerms: [],
    incoTermsLocation: "",
    procurementStrategies: "",
    openingDateTime: "",
    closingDateTime: "",
    totalHour: "",
    paymentTerms: "",
    instructionsAttachment: "",
    scopeOfwork: "",
    drawing: "",
    annexures: "",
    others: "",
    lineItems: [],
    supplierList: [],
    termsConditions: [],
    instructions: "",
    reminderEnabled: "",
    formCOMM: [],
    formTECH: [],
    otherCharges: [],
    qtnSubTotalLineItem: 0,
    qtnSubTotalOtherCharges: 0,
    qtnTotal: 0,
  });

  const [formInputs, setFormInputs] = useState({
    rfxType: "",
    productType: purchaseTypeCode || "",
    //  productType: rfxCategoryCode || "",
    rfxValue: "",
    rfxHeaderStatus: "RFQ Created",
    rfxbidType: "",
    rfxNoOfEvaluationType: "",
    rfxCurrency: "",
    rfxTechFocalPersonId: "",
    technicalApprovalType: "",
    plant: "",
    buyerResponsible: "",
    companyAddress: "", //i did'nt get in json
    billingAddress: "", //i did'nt get in json
    rfxVersion: "V0",
    buyerEmail: userData?.email,
    initiatorName: userData?.firstName,
    initiator: userData?.userId,
    createdOn: "", //i did'nt get in json
    buyerConact: userData?.contactNumber,
    deliveryAddressCodeDesc: "",
    rfxCategoryType: rfxCategoryType,
    rfxCategoryCode: rfxCategoryCode,
    rfxCategoryDesc: rfxCategoryDescription,
    rfqCreation: rfqCreation,
    rfxTitle: "",
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    rfxDescription: "",
    typeOfPurchase: "",
    otherCurrencies: [],
    headerIncoTerms: "",
    INCOTerms: "",
    incoTerms: [],
    incoTermsLocation: "",

    reminderEnabled: "",
    procurementStrategies: "",
    openingDateTime: "",
    closingDateTime: "",
    totalHour: "",
  });

  // ========== Completion Percentage ==========
  const calculateDraftProgress = (formData) => {
    let score = 0;

    // -------- Basic Info (30%) --------
    if (formData.rfxType) score += 5;
    if (formData.productType) score += 5;
    if (formData.rfxValue) score += 5;

    // -------- Header Info (20%) --------
    if (formData.rfxTitle) score += 5;
    const openDate = formData.openingDate;
    const openTime = formData.openingTime;
    const closeDate = formData.closingDate;
    const closeTime = formData.closingTime;
    if (openDate && openTime) score += 5;
    if (closeDate && closeTime) score += 5;
    if (openDate && openTime && closeDate && closeTime) score += 5;

    // -------- Description (10%) --------
    if (formData.rfxDescription) score += 10;

    // -------- Purchase Details (10%) --------
    if (formData.typeOfPurchase) score += 5;
    if (
      formData.paymentTerms ||
      (formData.otherCurrencies && formData.otherCurrencies.length > 0)
    )
      score += 5;

    // -------- Line Items (15%) --------
    const lineItems = formData.lineItems || [];
    if (lineItems.length > 0) {
      score += 15;
      // optional: check first line item for materialCode, quantity, etc.
    }

    // -------- Suppliers (15%) --------
    const suppliers = formData.supplierList || [];
    if (suppliers.length > 0) {
      score += 15;
    }

    return Math.min(score, 100);
  };

  const mapDraftToFormData = (draft) => ({
    rfxType: draft.rfxType || "",
    productType: draft.productType || purchaseTypeCode || "",
    rfxValue: draft.rfxValue || "",
    rfxHeaderStatus: draft.rfxHeaderStatus || "RFQ Created",
    rfxbidType: draft.rfxbidType || "",
    rfxNoOfEvaluationType: draft.rfxNoOfEvaluationType || "",
    rfxCurrency: draft.rfxCurrency || "",
    rfxTechFocalPersonId: draft.rfxTechFocalPersonId || "",
    technicalApprovalType: draft.technicalApprovalType || "",
    plant: draft.plant || "",
    buyerResponsible: draft.buyerResponsible || "",
    companyAddress: draft.companyAddress || "",
    billingAddress: draft.billingAddress || "",
    rfxVersion: draft.rfxVersion || "V0",
    buyerEmail: draft.buyerEmail || userData?.email || "",
    initiatorName: draft.initiatorName || userData?.firstName || "",
    initiator: draft.initiator || userData?.userId || "",
    createdOn: draft.createdOn || "",
    buyerConact: draft.buyerConact || userData?.contactNumber || "",
    deliveryAddressCodeDesc: draft.deliveryAddressCodeDesc || "",
    rfxCategoryType: draft.rfxCategoryType || rfxCategoryType || "",
    rfxCategoryCode: draft.rfxCategoryCode || rfxCategoryCode || "",
    rfxCategoryDesc: draft.rfxCategoryDesc || rfxCategoryDescription || "",
    rfqCreation: draft.rfqCreation || rfqCreation || "",
    rfxTitle: draft.rfxTitle || "",
    openingDate: draft.openingDate || "",
    openingTime: draft.openingTime || "",
    closingDate: draft.closingDate || "",
    closingTime: draft.closingTime || "",
    rfxDescription: draft.rfxDescription || "",
    typeOfPurchase: draft.typeOfPurchase || "",
    otherCurrencies: draft.otherCurrencies || [],
    headerIncoTerms: draft.headerIncoTerms || "",
    INCOTerms: draft.INCOTerms || "",
    incoTerms: draft.incoTerms || [],
    incoTermsLocation: draft.incoTermsLocation || "",
    reminderEnabled: draft.reminderEnabled || "",
    procurementStrategies: draft.procurementStrategies || "",
    openingDateTime: draft.openingDateTime || "",
    closingDateTime: draft.closingDateTime || "",
    totalHour: draft.totalHour || "",
    paymentTerms: draft.paymentTerms || "",
    instructionsAttachment: draft.instructionsAttachment || "",
    scopeOfwork: draft.scopeOfwork || "",
    drawing: draft.drawing || "",
    annexures: draft.annexures || "",
    others: draft.others || "",
    lineItems: draft.lineItems || [],
    supplierList: draft.supplierList || [],
    termsConditions: draft.termsConditions || [],
    instructions: draft.instructions || "",
    formCOMM: draft.formCOMM || [],
    formTECH: draft.formTECH || [],
    otherCharges: draft.otherCharges || [],
    qtnSubTotalLineItem: draft.qtnSubTotalLineItem || 0,
    qtnSubTotalOtherCharges: draft.qtnSubTotalOtherCharges || 0,
    qtnTotal: draft.qtnTotal || 0,
  });

  const getChangedFields = (oldData, newData) => {
    const changes = {};
    Object.keys(newData).forEach((key) => {
      if (!isEqual(oldData[key], newData[key])) {
        changes[key] = newData[key];
      }
    });
    return changes;
  };

  // const draftDataRef = useRef(null);
  useEffect(() => {
    draftDataRef.current = draftData;
  }, [draftData]);

  useEffect(() => {
    // const loadDraft = async () => {
    //   setIsLoadingDraft(true);
    //   try {
    //     const res = await ItemService.getDraftInitial(userData?.userId, "CREATE_PR_RFQ");
    //     if (res.success && res.exists && res.data) {
    //       const mappedData = mapDraftToFormData(res.data);
    //       console.log("Mapped Data in Create RFQ:", mappedData);
    //       previousSavedStateRef.current = JSON.parse(JSON.stringify(mappedData));
    //       setDraftData(res.data);
    //       console.log("Raw draft data:", res.data); //data is coming perfectly
    //       console.log("reminderEnabled in draft:", res.data?.reminderEnabled); // response is coming as "Yes"
    //       draftDataRef.current = res.data;
    //       // Populate all state variables from mappedData
    //       console.log("Only inco data: ", mappedData.incoTerms, "-------", mappedData.incoTermsLocation);
    //       setFormInputs({
    //         rfxType: mappedData.rfxType,
    //         productType: mappedData.productType,
    //         rfxValue: mappedData.rfxValue,
    //         rfxHeaderStatus: mappedData.rfxHeaderStatus,
    //         rfxbidType: mappedData.rfxbidType,
    //         rfxNoOfEvaluationType: mappedData.rfxNoOfEvaluationType,
    //         rfxCurrency: mappedData.rfxCurrency,
    //         rfxTechFocalPersonId: mappedData.rfxTechFocalPersonId,
    //         technicalApprovalType: mappedData.technicalApprovalType,
    //         plant: mappedData.plant,
    //         buyerResponsible: mappedData.buyerResponsible,
    //         companyAddress: mappedData.companyAddress,
    //         billingAddress: mappedData.billingAddress,
    //         rfxVersion: mappedData.rfxVersion,
    //         buyerEmail: mappedData.buyerEmail,
    //         initiatorName: mappedData.initiatorName,
    //         initiator: mappedData.initiator,
    //         createdOn: mappedData.createdOn,
    //         buyerConact: mappedData.buyerConact,
    //         deliveryAddressCodeDesc: mappedData.deliveryAddressCodeDesc,
    //         rfxCategoryType: mappedData.rfxCategoryType,
    //         rfxCategoryCode: mappedData.rfxCategoryCode,
    //         rfxCategoryDesc: mappedData.rfxCategoryDesc,
    //         rfqCreation: mappedData.rfqCreation,
    //         rfxTitle: mappedData.rfxTitle,
    //         openingDate: mappedData.openingDate,
    //         openingTime: mappedData.openingTime,
    //         closingDate: mappedData.closingDate,
    //         closingTime: mappedData.closingTime,
    //         rfxDescription: mappedData.rfxDescription,
    //         typeOfPurchase: mappedData.typeOfPurchase,
    //         otherCurrencies: mappedData.otherCurrencies,
    //         headerIncoTerms: mappedData.headerIncoTerms,
    //         INCOTerms: mappedData.INCOTerms,
    //         incoTerms: mappedData.incoTerms,
    //         incoTermsLocation: mappedData.incoTermsLocation,
    //         reminderEnabled: mappedData.reminderEnabled,
    //         procurementStrategies: mappedData.procurementStrategies,
    //         openingDateTime: mappedData.openingDateTime,
    //         closingDateTime: mappedData.closingDateTime,
    //         totalHour: mappedData.totalHour,
    //         paymentTerms: mappedData.paymentTerms,
    //         instructionsAttachment: mappedData.instructionsAttachment,
    //         scopeOfwork: mappedData.scopeOfwork,
    //         drawing: mappedData.drawing,
    //         annexures: mappedData.annexures,
    //         others: mappedData.others,

    //       });
    //       console.log("formInputs after loading draft:", formInputs); // But here reminderEnabled is still empty
    //       // Set line items based on rfqCreation type
    //       if (rfqCreation === "PR") {
    //         setLineItemData(mappedData.lineItems || []);
    //       } else {
    //         setPRLineItemsData(mappedData.lineItems || PRLineItemInitialData);
    //       }
    //       setSupplierData(mappedData.supplierList || []);
    //       if (mappedData.termsConditions && mappedData.termsConditions.length > 0) {
    //         setTermsConditionsData(mappedData.termsConditions);
    //       }
    //       setEditorContent(mappedData.instructions || "");
    //       setChargesSelected(mappedData.otherCharges || []);
    //       // Update open/close inputs
    //       setOpenCloseInput({
    //         openingDate: mappedData.openingDate || "",
    //         openingTime: mappedData.openingTime || "",
    //         closingDate: mappedData.closingDate || "",
    //         closingTime: mappedData.closingTime || "",
    //         totalHour: mappedData.totalHour || "",
    //         status: false,
    //         msg: "",
    //       });
    //     } else if (res.success && !res.exists) {
    //       // No draft exists; create one with empty data
    //       const emptyData = createEmptyFormData();
    //       previousSavedStateRef.current = JSON.parse(JSON.stringify(emptyData));
    //       const response = await ItemService.createDraft(userData?.userId, "CREATE_PR_RFQ");
    //       if (response.success && response.data) {
    //         setDraftData(response.data);
    //       }
    //       // Optionally set initial form state to empty (but preserve some defaults)
    //       setFormInputs(prev => ({ ...prev, ...emptyData }));
    //     }
    //   } catch (error) {
    //     console.error("Failed to load draft", error);
    //   } finally {
    //     setIsLoadingDraft(false);
    //   }
    // };

    const loadDraft = async () => {
      setIsLoadingDraft(true);
      try {
        if (draftIdParam) {
          // Load specific draft by ID
          const res = await ItemService.getDraftById(
            draftIdParam,
            "MANUAL_RFQ",
            userData?.userId,
          );
          if (res?.success && res?.data) {
            const draft = res.data;
            const mappedData = mapDraftToFormData(draft);
            previousSavedStateRef.current = JSON.parse(
              JSON.stringify(mappedData),
            );
            setDraftData(res.data);
            // populateFormState(mappedData);
            setDraftData(draft);
            draftDataRef.current = draft;
            previousFullDataRef.current = JSON.parse(
              JSON.stringify(getFullFormData()),
            );
          } else {
            toast.error("Failed to load draft.");
            navigate(Constants.SOURCING_BUYER_REQUEST_FOR_QUOTATION); // adjust path
          }
        } else if (newDraftParam || !draftIdParam) {
          // Create a new draft
          const createRes = await ItemService.createDraft(
            userData?.userId,
            "MANUAL_RFQ",
          );
          if (createRes?.success && createRes?.data) {
            const draft = createRes.data;
            const emptyData = createEmptyFormData();
            // populateFormState(emptyData);
            setFormInputs(emptyData);
            setDraftData(draft);
            draftDataRef.current = draft;
            previousFullDataRef.current = JSON.parse(
              JSON.stringify(getFullFormData()),
            );
          } else {
            // Fallback: use empty form without draft
            const emptyData = createEmptyFormData();
            // populateFormState(emptyData);
            setFormInputs(emptyData);
          }
        }
      } catch (error) {
        console.error("Draft loading error:", error);
        toast.error("Error loading draft.");
      } finally {
        setIsLoadingDraft(false);
      }
    };

    if (userData?.userId) {
      loadDraft();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userData?.userId, draftIdParam, newDraftParam]);

  const [getOpenCloseInput, setOpenCloseInput] = useState({
    openingDate: "",
    openingTime: "",
    closingDate: "",
    closingTime: "",
    totalHour: "",
    status: false,
    msg: "",
  });
  const modalData = {
    title: "RFQ Creation",
    successMsg: "",
  };
  // View attachment files
  const [getShowFileViewModal, setShowFileViewModal] = useState(false);
  const [getFileViewData, setFileViewData] = useState(null);
  // Dedicated viewer for questionnaire (TECH/COMM) attachments. Kept separate
  // from the document viewer above so deleting a questionnaire file only clears
  // that question's stored attachment id. hbFileViewKey remembers which
  // formAnswers entry the open modal belongs to.
  const [getShowHBFileViewModal, setShowHBFileViewModal] = useState(false);
  const [getHBFileViewData, setHBFileViewData] = useState(null);
  const [hbFileViewKey, setHBFileViewKey] = useState(null);

  const toggleCardVisibility = () => {
    setCardVisible(!isCardVisible);
  };
  const toggleCardVisibility2 = () => {
    setCardVisible2(!isCardVisible2);
  };
  const toggleCardVisibility3 = () => {
    setCardVisible3(!isCardVisible3);
  };
  const toggleCardVisibility5 = () => {
    setCardVisible5(!isCardVisible5);
  };
  const toggleCardVisibility6 = () => {
    setCardVisible6(!isCardVisible6);
  };
  const toggleCardVisibility7 = () => {
    setCardVisible7(!isCardVisible7);
  };
  const toggleCardVisibility8 = () => {
    setCardVisible8(!isCardVisible8);
  };
  // const toggleCardVisibility8_1 = () => {
  //   setCardVisible8_1(!isCardVisible8_1);
  // };
  const toggleCardVisibility9 = () => {
    setCardVisible9(!isCardVisible9);
  };
  // const toggleCardVisibility9_1 = () => {
  //   setCardVisible9_1(!isCardVisible9_1);
  // };
  const toggleCardVisibility10 = () => {
    setCardVisible10(!isCardVisible10);
  };
  const toggleCardVisibilityCS = () => {
    setCardVisibleCS(!isCardVisibleCS);
  };

  const onInputChange = ({ target: { name, value } }) => {
    setFormInputs((formInputs) => ({ ...formInputs, [name]: value }));
    // console.log("onInputChange => formInputs", formInputs);
  };

  // Commercial and Technical Total Weightage share a single 100-point budget, so
  // entering one auto-fills the other as (100 - value): e.g. Commercial 80 sets
  // Technical to 20. Clearing a field clears both, returning the pair to the
  // untouched state. Values are clamped to 0–100 so the complement never goes
  // negative or past 100. Only splits for Technical + Commercial RFQs; for a
  // single-type RFQ it behaves like a plain input and never touches the (hidden)
  // other field.
  const onWeightageSplitChange = ({ target: { name, value } }) => {
    if (!(isCommercialRFQ && isTechnicalRFQ)) {
      setFormInputs((prev) => ({ ...prev, [name]: value }));
      return;
    }
    const complementName =
      name === "commercialTotalWeigtage"
        ? "technicalTotalWeight"
        : "commercialTotalWeigtage";
    setFormInputs((prev) => {
      if (value === "") {
        return { ...prev, [name]: "", [complementName]: "" };
      }
      const entered = Math.max(0, Math.min(100, Number(value) || 0));
      return { ...prev, [name]: entered, [complementName]: 100 - entered };
    });
  };

  // Minimum Technical Total weightage is capped at 100 — clamp on entry so the
  // field itself can't hold a value greater than 100 (0/empty = no minimum set).
  const onMinTechWeightChange = ({ target: { name, value } }) => {
    if (value === "") {
      setFormInputs((prev) => ({ ...prev, [name]: "" }));
      return;
    }
    const capped = Math.max(0, Math.min(100, Number(value) || 0));
    setFormInputs((prev) => ({ ...prev, [name]: capped }));
  };

  // This is for Text Editor
  const handleEditorChange = (content) => {
    setEditorContent(content);
  };

  const suppliersColumns = [
    {
      name: "Supplier ID",
      selector: (row) => row.AssociateNumber || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btnInfo"
          // onClick={() => detailedPage(row.AssociateNumber)}
        >
          {row.AssociateNumber || "-"}{" "}
        </button>
      ),
      width: "120px",
    },
    {
      name: "Status",
      selector: (row) => row.status,
      sortable: true,
      cell: (row) => (
        <>
          <TableStatusField status={row.status} />
        </>
      ),
      width: "170px",
    },

    {
      name: "Supplier openDate",
      selector: (row) => row.organisationName,
      sortable: true,
      width: "180px",
    },
    {
      name: "SAP Number",
      selector: (row) => row.sapAssociateNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Contact Person",
      selector: (row) => row.contactfirstName || "--",
      sortable: true,
      width: "150px",
    },

    {
      name: "Contact Number",
      selector: (row) => row.contactNumber || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "EMail",
      selector: (row) => row.email,
      sortable: true,
      width: "250px",
    },
    {
      name: "initiator",
      selector: (row) => row.initiator || "--",
      sortable: true,
      width: "100px",
    },
    {
      name: "ICV Score %",
      selector: (row) => row.totalScore || "--",
      sortable: true,
      width: "150px",
    },
    {
      name: "Category",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            // onClick={() => categoryItemShowModal(row.vendorCategory)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.vendorCategory?.length || 0}{" "}
          </span>
        </>
      ),
      width: "120px",
    },
    {
      name: "Created Date",
      selector: (row) => formatDate(row.createdAt),
      sortable: true,
      width: "160px",
    },
    {
      name: "Company Code",
      cell: (row) => (
        <>
          <span> {row.companyCode} </span>
        </>
      ),
      width: "150px",
    },
  ];

  const [getModalInfo, setModalInfo] = useState(modalData);
  const [getShowSuccessModal, setShowSuccessModal] = useState(false);
  const onSuccessfullyRegistered = () => {
    setShowSuccessModal(true);
  };
  const hideSuccessModal = () => {
    setShowSuccessModal(false);
  };

  const failureModalData = {
    title: "Warning",
    ErrorMsg: "",
  };
  const [getShowFailureModal, setShowFailureModal] = useState(false);
  const [getErrorFields, setErrorFields] = useState([]);
  const [getFailureModal] = useState(failureModalData);

  const hideFailureModal = () => {
    setShowFailureModal(false);
  };
  // console.log(">>formInputs",formInputs)
  // Get Dropdown data select
  // useEffect(() => {
  //   // console.log(">>datarfq", getDropdownData);
  //   if (getDropdownData?.name) {
  //     if (getDropdownData?.textField === "INCOTerms") {
  //       setFormInputs((formInputs) => ({
  //         ...formInputs,
  //         INCOTerms: getDropdownData?.name,
  //         INCOTermsCode: getDropdownData?.code,
  //         INCOTermsDesc: getDropdownData?.description,

  //         incoTerms: getDropdownData?.selected, // ✅ store full selected array
  //       }));
  //     }
  //     else if (getDropdownData?.textField === "otherCurrencies") {

  //       setFormInputs((prev) => ({
  //         ...prev,
  //         otherCurrencies: getDropdownData?.selected || [],
  //       }));

  //     }
  //     else if (getDropdownData?.name) {
  //       setFormInputs((formInputs) => ({
  //         ...formInputs,
  //         [getDropdownData?.textField]: getDropdownData?.name,
  //         [getDropdownData?.textCode]: getDropdownData?.code,
  //         [getDropdownData?.textDesc]: getDropdownData?.description,
  //       }));
  //     } else {
  //       setFormInputs((formInputs) => ({
  //         ...formInputs,
  //         [getDropdownData?.textField]: getDropdownData?.name,
  //         [getDropdownData?.textCode]: getDropdownData?.code,
  //         [getDropdownData?.textDesc]: getDropdownData?.description,
  //       }));
  //     }
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [getDropdownData]);

  useEffect(() => {
    if (!getDropdownData) return;

    const { textField, selected, name, code, description, textCode, textDesc } =
      getDropdownData;

    // Multiselect fields (no single name)
    if (textField === "INCOTerms") {
      setFormInputs((prev) => ({
        ...prev,
        INCOTerms: name || "",
        INCOTermsCode: code || "",
        INCOTermsDesc: description || "",
        incoTerms: selected || [],
      }));
    } else if (textField === "otherCurrencies") {
      setFormInputs((prev) => ({
        ...prev,
        otherCurrencies: selected || [],
      }));
    } else if (name) {
      // Single-select fields
      setFormInputs((prev) => ({
        ...prev,
        [textField]: name,
        [textCode]: code,
        [textDesc]: description,
      }));
    }
  }, [getDropdownData]);

  // Dedicated handler for the RFQ Type dropdown: keeps the selection in its own
  // state (so other dropdowns can't overwrite it) AND updates formInputs so the
  // chosen value is shown back in the input. Mirrors the single-select branch of
  // the getDropdownData effect above.
  // useCallback keeps a stable reference — ComboboxField calls getvalue from an
  // effect keyed on it, so a new function each render would loop infinitely.
  const handleRfqTypeChange = useCallback((sel) => {
    setRfqTypeSelection(sel);
    if (sel?.name) {
      setFormInputs((prev) => ({
        ...prev,
        rfxType: sel.name,
        rfxTypeCode: sel.rfxTypeCode || sel.code || "",
        rfxTypeDesc: sel.rfxTypeDesc || sel.description || "",
      }));
    }
  }, []);

  // Runs every create-RFQ validation and returns the failure messages plus the
  // set of tabs each failure belongs to. Extracted from the submit handler so
  // the same rules also power the live "clear the red tab once fixed" effect
  // (see the useEffect after getSupplierData) — one source of truth, no drift.
  const computeValidation = () => {
    const requiredFields = [];
    const errorTabs = {};
    const addError = (tab, msg) => {
      requiredFields.push(msg);
      errorTabs[tab] = true;
    };

    if (formInputs.rfxValue === "") {
      addError("rqf-titlle", "* Please enter the Estimated RFQ Value.");
    }
    if (getSupplierData.length === 0) {
      addError("addSuppliers", "* Add atleast one supplier.");
    }
    if (dynamicFormDataCOMM.length === 0) {
      addError("technicalCommercial", "*Add atleast one Form: COMM- Spares.");
    }
    if (dynamicFormDataTECH.length === 0) {
      addError(
        "technicalCommercial",
        "* Add atleast one Form : TECH - Spares.",
      );
    }
    const minTechWeight = Number(formInputs.minimumTechnicalTotalWeight) || 0;
    const commTotalWeight = Number(formInputs.commercialTotalWeigtage) || 0;
    const techTotalWeight = Number(formInputs.technicalTotalWeight) || 0;
    // For a Technical + Commercial RFQ the two Total Weightage values are a
    // split of a single 100-point budget, so they must add up to exactly 100
    // (e.g. Commercial 40 + Technical 60). Only enforced once the user has
    // entered at least one of them, so an untouched form isn't blocked.
    if (
      isCommercialRFQ &&
      isTechnicalRFQ &&
      (commTotalWeight > 0 || techTotalWeight > 0) &&
      commTotalWeight + techTotalWeight !== 100
    ) {
      addError(
        "rqf-titlle",
        `* Commercial Total weightage (${commTotalWeight}) and Technical Total weightage (${techTotalWeight}) must add up to 100.`,
      );
    }
    // Minimum Technical Total weightage may be any value from 1 to 100 and is
    // no longer tied to the Technical Total weightage.
    if (minTechWeight > 100) {
      addError(
        "rqf-titlle",
        `* Minimum Technical Total weightage (${minTechWeight}) must be between 1 and 100.`,
      );
    }
    // Each questionnaire block must be fully weighted: the sum of its question
    // weightages has to equal the block's budget (100). Only checked when the
    // block applies and has questions, so an unused/empty block isn't flagged
    // here (the "add at least one Form" checks above cover the empty case).
    if (
      isCommercialRFQ &&
      dynamicFormDataCOMM.length > 0 &&
      commercialWeightSum !== defaultCommercialTotalWeigtage
    ) {
      addError(
        "technicalCommercial",
        `* Commercial total weightage (${commercialWeightSum}) must equal ${defaultCommercialTotalWeigtage}.`,
      );
    }
    if (
      isTechnicalRFQ &&
      dynamicFormDataTECH.length > 0 &&
      technicalWeightSum !== defaultTechnicalTotalWeight
    ) {
      addError(
        "technicalCommercial",
        `* Technical total weightage (${technicalWeightSum}) must equal ${defaultTechnicalTotalWeight}.`,
      );
    }
    if (getOpenCloseInput.status === false) {
      addError(
        "schedule",
        getOpenCloseInput.msg === ""
          ? "* Please update Opening and Closing Date, Time"
          : getOpenCloseInput.msg,
      );
    }

    return { requiredFields, errorTabs };
  };

  /* submit button */
  const handleCreateRFQ = async () => {
    const { requiredFields, errorTabs } = computeValidation();

    // If anything failed, highlight the offending tabs and stop.
    if (requiredFields.length > 0) {
      setTabErrors(errorTabs);
      setErrorFields(requiredFields);
      setShowFailureModal(true);
      return;
    }
    // All validations passed — clear any previous tab highlights.
    setTabErrors({});

    formInputs.items =
      rfqCreation === "PR" ? getLineItemData : getPRLineItemsData;
    formInputs.supplierList = getSupplierData;
    formInputs.termsConditions = termsConditionsData;
    formInputs.instructions = editorContent;
    formInputs.formCOMM = dynamicFormDataCOMM.map((q) => ({
      ...q,
      answer: formAnswers?.[`formCOMM-${q.componentId}`] ?? "",
      attachment: formAnswers?.[`formCOMM-${q.componentId}-attachment`] ?? "",
    }));
    formInputs.formTECH = dynamicFormDataTECH.map((q) => ({
      ...q,
      answer: formAnswers?.[`formTECH-${q.componentId}`] ?? "",
      attachment: formAnswers?.[`formTECH-${q.componentId}-attachment`] ?? "",
    }));

    // open and close date
    formInputs.openingDateTime =
      getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime;
    formInputs.closingDateTime =
      getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime;
    formInputs.totalHour = getOpenCloseInput.totalHour;

    formInputs.openingDate = getOpenCloseInput.openingDate;
    formInputs.openingTime = getOpenCloseInput.openingTime;
    formInputs.closingDate = getOpenCloseInput.closingDate;
    formInputs.closingTime = getOpenCloseInput.closingTime;

    // Other Charges
    formInputs.othersCharge = getChargesSelected;
    formInputs.qtnSubTotalLineItem = subTotalValue;
    formInputs.qtnSubTotalOtherCharges = getOtherChargesValue;
    formInputs.qtnTotal = (subTotalValue || 0) + (getOtherChargesValue || 0);

    const fullData = getFullFormData(); // or construct from current state
    formInputs.completionPercentage = calculateDraftProgress(fullData);

    // Also add draft metadata if needed (like in first page)
    formInputs.draftData = {
      draftUserId: userData?.userId,
      draftDocumentNumber: draftDataRef.current?.documentNumber,
      draftType: draftDataRef.current?.draftType,
    };

    let obj = {
      data: formInputs,
    };
    setDisabled(false);
    await ItemService.addRfx(obj).then((item) => {
      // console.log(">> item! ", item);
      if (item?.status === 200) {
        modalData.successMsg = item?.message;
        setModalInfo(modalData);
        // dispatch(getRfqQuotation({})).then(() => {
        //   onSuccessfullyRegistered();
        // });
        onSuccessfullyRegistered();
      } else {
        toast.error(item?.message || "Please try again !!", {
          duration: 4000,
          position: "top-right",
        });
      }
    });
    setDisabled(true);
  };

  /* suppplierModalShow */
  const [getSupplierModal, setSupplierModal] = useState(false);
  const suppplierModalShow = () => {
    setSupplierModal(true);
  };
  const supplerMoadHide = () => {
    setSupplierModal(false);
  };
  /* selectedSupplierIds */
  const [selectedSuppliers, setSelectedSuppliers] = useState([]);
  const [getSupplierData, setSupplierData] = useState([]);
  const handleSelectedRows = (selectedRows) => {
    setSelectedSuppliers(selectedRows);
  };

  // Once a submit has flagged tabs red, re-run validation as the user edits and
  // drop the highlight (and its error icon) from any tab whose problems are now
  // resolved — so fixing an issue clears the red button without another submit.
  // We only ever REMOVE highlights here, never add, so no tab turns red before
  // the user has actually tried to submit. Placed after getSupplierData (a
  // dependency) so the deps array below is safe to evaluate.
  useEffect(() => {
    setTabErrors((prev) => {
      if (Object.keys(prev).length === 0) return prev;
      const { errorTabs } = computeValidation();
      const next = {};
      Object.keys(prev).forEach((tab) => {
        if (errorTabs[tab]) next[tab] = true;
      });
      // next is always a subset of prev, so an equal key count means nothing
      // was resolved — return the same reference so React skips the re-render.
      return Object.keys(next).length === Object.keys(prev).length
        ? prev
        : next;
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formInputs,
    rfqTypeSelection,
    getSupplierData,
    dynamicFormDataCOMM,
    dynamicFormDataTECH,
    commercialWeightSum,
    technicalWeightSum,
    getOpenCloseInput,
  ]);

  const handlePassDataToParent = (data) => {
    // console.log("Data received from child:", data);
    // You can now use this data in the parent component

    setSupplierData((prevData) => {
      // Combine previous data and filter out duplicates based on id
      const updatedData = [
        ...prevData,
        ...data.filter(
          (newObj) =>
            !prevData.some(
              (existingObj) =>
                existingObj.AssociateNumber === newObj.AssociateNumber,
            ),
        ),
      ];

      return updatedData;
    });
  };

  const [termsConditionsData, setTermsConditionsData] = useState([
    {
      id: 1,
      name: "Terms and Conditions",
      status: true,
      disabled: true,
    },
    {
      id: 2,
      name: "Code of Conduct",
      status: false,
    },
    {
      id: 3,
      name: "Packaging Requirement",
      status: false,
    },
    {
      id: 4,
      name: "Others",
      status: false,
    },
    // {
    //   id: 5,
    //   name: "Others",
    //   status: false,
    // },
    // {
    //   id: 6,
    //   name: "Packaging Requirement",
    //   status: false,
    // },
    // {
    //   id: 7,
    //   name: "Trucking H&S Requirements",
    //   status: false,
    // },
  ]);

  const handleTermsConditionCheckBox = (id) => {
    // Update the status of the item based on its id
    const updatedData = termsConditionsData.map((item) => {
      if (item.id === id) {
        return { ...item, status: !item.status };
      }
      return item;
    });
    // Update the state with the modified data
    setTermsConditionsData(updatedData);
  };

  /*  PRLineItem*/
  let PRLineItemInitialCol = [
    {
      name: "Document Item Nr",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "180px",
    },
    {
      name: "Item Text",
      selector: (row) => row.local_id || "--",
      sortable: true,
      width: "110px",
      cell: (row) => (
        <>
          <span
            style={{ marginLeft: "12px" }}
            onClick={() => lineItemShowModal(row.itemTextData)}
          >
            <i className="bi bi-calendar2-week iconTable"></i>
          </span>
          <span className="suppliersIcon">
            {" "}
            {row.itemTextData?.length || 0}{" "}
          </span>
        </>
      ),
    },
    {
      name: "Material/Service ",
      selector: (row) => row.materialCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialCode"
          placeholder=""
          value={row.materialCode || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Description",
      selector: (row) => row.materialDescription || "--",
      cell: (row) => (
        <TextAreaField
          className="inputBox mt-1"
          name="materialDescription"
          placeholder=""
          value={row.materialDescription || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Material Group ",
      selector: (row) => row.materialGroup || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="materialGroup"
          placeholder=""
          value={row.materialGroup || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Quantity ",
      selector: (row) => row.purchaseQuantity || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="purchaseQuantity"
          placeholder=""
          value={row.purchaseQuantity || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "UOM ",
      selector: (row) => row.orderUnitOfMeasure || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="orderUnitOfMeasure"
          placeholder=""
          value={row.orderUnitOfMeasure || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Unit Price ",
      selector: (row) => row.orderPriceUnit || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="orderPriceUnit"
          placeholder=""
          value={row.orderPriceUnit || ""}
          onChange={(event) => handleInputChange(row.local_id, event, "Number")}
        />
      ),
      width: "200px",
    },
    {
      name: "Item Value ",
      selector: (row) => row.netValue || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="netValue"
          placeholder=""
          value={row.netValue || 0}
          disabled={true}
        />
      ),
      width: "200px",
    },
    {
      name: "Currency ",
      selector: (row) => row.currencyCode || "INR",
      width: "200px",
    },
    {
      name: "Tax Amount",
      selector: (row) => row.taxAmount || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxAmount"
          placeholder=""
          value={row.taxAmount || 0}
          disabled={true}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "VAT Code % ",
      selector: (row) => row.taxCode || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          name="taxCode"
          placeholder=""
          value={row.taxCode}
          onChange={(event) =>
            handleInputChange(row.local_id, event, "Number", "VAT")
          }
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Delivery Date",
      selector: (row) => row.deliveryDate || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          type="date"
          name="deliveryDate"
          placeholder=""
          value={row.deliveryDate || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      width: "200px",
    },
    {
      name: "Plant",
      selector: (row) => row.plant || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="plant"
          placeholder=""
          value={row.plant || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Storage Location",
      selector: (row) => row.storageLocn || "--",
      cell: (row) => (
        <InputField
          className="inputBox mt-1"
          // label="Please Enter the Remarks*"
          name="storageLocn"
          placeholder=""
          value={row.storageLocn || ""}
          onChange={(event) => handleInputChange(row.local_id, event)}
        />
      ),
      sortable: true,
      width: "200px",
    },
    {
      name: "Prefered Venodor",
      selector: (row) => row.preferedVendor || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Suggested Vendor",
      selector: (row) => row.suggestedVendor || "--",
      sortable: true,
      width: "200px",
    },
    {
      name: "Delete",
      selector: (row) => row.local_id || "--",
      sortable: true,
      cell: (row) => (
        <button
          className="btn btn-danger"
          onClick={() => removePOItemRow(row.local_id)}
        >
          <i className="bi bi-trash3"></i>
        </button>
      ),
      width: "120px",
    },
  ];
  let PRLineItemInitialData = [
    {
      local_id: 1,
      rfxNr: 1,
      itemTextData: [],
      statusItem: "In Release",
      // currency: getCurrencyDropdown.name || "Rupee",
      // currencyCode: getCurrencyDropdown.code || "INR",
      currency: "Rupee",
      currencyCode: "INR",
      taxCode: 0,
      taxAmount: 0,
    },
  ];

  // PO items columns Details
  const lineItemColInfo = [
    {
      name: "Code",
      cell: (row) => <span>{row.documentId} </span>,
      width: "200px",
    },
    {
      name: "Text",
      cell: (row) => <span>{row.documentText} </span>,
      width: "250px",
    },
  ];

  // Show Item level data
  const [getItemLevelData, setItemLevelData] = useState([]);
  const [getItemLevelColumns, setItemLevelColumns] = useState([]);
  const [getModalTitle, setModalTitle] = useState("");
  const [itemLevelModalShow, setItemLevelModalShow] = useState(false);

  // OnClick on lineItem  Data
  const lineItemShowModal = (itemLevelData) => {
    setItemLevelData(itemLevelData);
    setItemLevelColumns(lineItemColInfo);
    setModalTitle("Item Text Details");
    setItemLevelModalShow(true);
  };
  const itemLevelHideModal = () => {
    setItemLevelModalShow(false);
  };

  const [getPRLineItemsData, setPRLineItemsData] = useState(
    PRLineItemInitialData,
  );

  const handleInputChange = (local_id, event, type, vat) => {
    const { name, value } = event.target;
    if (type === "Number" && vat === undefined) {
      if (isValidNumber(value)) {
        setPRLineItemsData((prevRows) =>
          prevRows.map((row) => {
            return row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  netValue:
                    name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value,
                  taxAmount:
                    (Number(row.taxCode) / 100) *
                    (name === "purchaseQuantity"
                      ? row.orderPriceUnit * value
                      : row.purchaseQuantity * value),
                }
              : row;
          }),
        );
      }
    } else if (type === "Number" && vat === "VAT") {
      if (isValidNumber(value)) {
        setPRLineItemsData((prevRows) =>
          prevRows.map((row) =>
            row.local_id === local_id
              ? {
                  ...row,
                  [name]: value,
                  taxAmount:
                    name === "taxCode"
                      ? (Number(value) / 100) *
                        (Number(row.purchaseQuantity || 0) *
                          Number(row.orderPriceUnit || 0))
                      : 0,
                }
              : row,
          ),
        );
      }
    } else {
      setPRLineItemsData((prevRows) =>
        prevRows.map((row) =>
          row.local_id === local_id ? { ...row, [name]: value } : row,
        ),
      );
    }
    // getTotalCount()
  };

  // Add or Remove Line Item
  const addPOItemRow = () => {
    setPRLineItemsData((prevRows) => {
      PRLineItemInitialData[0].local_id = prevRows.length + 1;
      PRLineItemInitialData[0].rfxNr = prevRows.length + 1; // make it to 3 digit 001, 002
      return [...prevRows, ...PRLineItemInitialData];
    });
  };
  const removePOItemRow = (local_id) => {
    setPRLineItemsData((prevPrograms) =>
      prevPrograms.filter((program) => program.local_id !== local_id),
    );
  };

  //Load Master Data
  const getMasterDataFunc = async () => {
    let obj1 = {
      codeType: "paymentTerm",
    };
    await ItemService.getMasterData(obj1).then((item) => {
      if (item?.status === 200) {
        setpaymentTerm(item?.data);
      } else {
        setpaymentTerm([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj2 = {
      codeType: "RFxType",
    };

    await ItemService.getMasterData(obj2).then((item) => {
      if (item?.status === 200) {
        setRFxType(item?.data);
      } else {
        setRFxType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    // let obj3 = {
    //   codeType: "RFxProductType",
    // };
    // await ItemService.getMasterData(obj3).then((item) => {
    //   if (item?.status === 200) {
    //     setRFxProductType(item?.data);
    //   } else {
    //     setRFxProductType([]);
    //     console.log(">> Error: Loading getMasterData");
    //   }
    // });

    let obj3 = {
      codeType: "RFxProductType",
    };
    await ItemService.getMasterData(obj3).then((item) => {
      if (item?.status === 200) {
        setRFxProductType(item?.data);

        const matchedProduct = item?.data?.find(
          (p) => p.code === purchaseTypeCode,
        );

        if (matchedProduct) {
          setFormInputs((prev) => ({
            ...prev,
            productType: matchedProduct.name,
            productTypeCode: matchedProduct.code,
            productTypeDesc: matchedProduct.description,
          }));
        }
      } else {
        setRFxProductType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj4 = {
      codeType: "CompanyAddress",
    };
    await ItemService.getMasterData(obj4).then((item) => {
      if (item?.status === 200) {
        setCompanyAddress(item?.data);
      } else {
        setCompanyAddress([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj5 = {
      codeType: "BillingAddress",
    };
    await ItemService.getMasterData(obj5).then((item) => {
      if (item?.status === 200) {
        setBillingAddress(item?.data);
      } else {
        setBillingAddress([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj6 = {
      codeType: "DeliveryAddress",
    };
    await ItemService.getMasterData(obj6).then((item) => {
      if (item?.status === 200) {
        setDeliveryAddress(item?.data);
      } else {
        setDeliveryAddress([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj7 = {
      codeType: "currency",
    };
    await ItemService.getMasterData(obj7).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setcurrency(item?.data);
      } else {
        setcurrency([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj8 = {
      codeType: "INCOTerms",
    };
    await ItemService.getMasterData(obj8).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setINCOTerms(item?.data);
      } else {
        setINCOTerms([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj9 = {
      codeType: "RfxPurchaseType",
    };
    await ItemService.getMasterData(obj9).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setRfxPurchaseType(item?.data);
      } else {
        setRfxPurchaseType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj10 = {
      codeType: "RfxBidType",
    };
    await ItemService.getMasterData(obj10).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setRfxBidType(item?.data);
      } else {
        setRfxBidType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj11 = {
      codeType: "TechnicalApprovalType",
    };
    await ItemService.getMasterData(obj11).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setTechnicalApprovalType(item?.data);
      } else {
        setTechnicalApprovalType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });

    let obj12 = {
      codeType: "RfxNoOfEvaluationType",
    };
    await ItemService.getMasterData(obj12).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setRfxNoOfEvaluationType(item?.data);
      } else {
        setRfxNoOfEvaluationType([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj13 = {
      codeType: "Plant",
    };
    await ItemService.getMasterData(obj13).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setPlant(item?.data);
      } else {
        setPlant([]);
        console.log(">> Error: Loading getMasterData");
      }
    });
    let obj14 = {
      codeType: "OtherChargesID",
    };
    await ItemService.getMasterData(obj14).then((item) => {
      if (item?.status === 200) {
        setChargesSelcetion(item?.data);
      } else {
        setChargesSelcetion([]);
      }
    });
  };
  // const loadLineItem = async () => {
  //   let obj6 = {
  //     purchaseReqDocumentNr: approvedSelectedRows,
  //     page: 1,
  //     per_page: 1000,
  //   };
  //   await ItemService.getPRLineItems(obj6).then((item) => {
  //     if (item?.status === 200) {
  //       const updatedItemData = item?.data.map((obj, index) => ({
  //         ...obj,
  //         rfxItemNr: index + 1,
  //         local_id: index + 1,
  //       }));
  //       console.log("Data", item);
  //       setLineItemData(updatedItemData);
  //       setLineItemTotal(item?.total);
  //     } else {
  //       setLineItemData([]);
  //       console.log(">> Error: Loading Line Items");
  //     }
  //   });
  // };

  //   const loadLineItem = async () => {
  //   let obj6 = {
  //     purchaseReqDocumentNr: approvedSelectedRows,
  //     page: 1,
  //     per_page: 1000,
  //   };
  //   await ItemService.getPRLineItems(obj6).then((item) => {
  //     if (item?.status === 200) {
  //       const updatedItemData = item?.data.map((obj, index) => ({
  //         ...obj,
  //         rfxItemNr: index + 1,
  //         local_id: index + 1,
  //       }));
  //       console.log("Data", item);
  //       setLineItemData(updatedItemData);
  //       setLineItemTotal(item?.total);

  //       if (updatedItemData.length > 0 && updatedItemData[0]?.plant) {
  //         setFormInputs((prev) => ({
  //           ...prev,
  //           plant: updatedItemData[0].plant,
  //           plantCode: updatedItemData[0].plant,
  //         }));
  //       }

  //     } else {
  //       setLineItemData([]);
  //       console.log(">> Error: Loading Line Items");
  //     }
  //   });
  // };

  const loadLineItem = async () => {
    let obj6 = {
      purchaseReqDocumentNr: approvedSelectedRows,
      page: 1,
      per_page: 1000,
    };
    await ItemService.getPRLineItems(obj6).then((item) => {
      if (item?.status === 200) {
        const updatedItemData = item?.data.map((obj, index) => ({
          ...obj,
          rfxItemNr: index + 1,
          local_id: index + 1,
        }));
        setLineItemData(updatedItemData);
        setLineItemTotal(item?.total);

        if (updatedItemData.length > 0 && updatedItemData[0]?.plant) {
          setFormInputs((prev) => ({
            ...prev,
            plant: updatedItemData[0].plant,
            plantCode: updatedItemData[0].plant,
          }));
        }
      } else {
        setLineItemData([]);
        console.log(">> Error: Loading Line Items");
      }
    });

    if (approvedSelectedRows?.length > 0) {
      let objHeader = {
        documentNumber: approvedSelectedRows[0], // first selected PR
      };
      await ItemService.getPRDetail(objHeader).then((item) => {
        if (item?.status === 200) {
          const headerData = item?.data;
          // setFormInputs((prev) => ({
          //   ...prev,
          //   // Payment Terms
          //   paymentTerms: headerData?.paymentTerms || "",
          //   paymentTermsCode: headerData?.paymentTerms || "",

          //   // INCO Terms
          //   INCOTerms: headerData?.incoTerms || "",
          //   incoTerms: headerData?.incoTerms || "",
          //   INCOTermsCode: headerData?.incoTerms || "",

          //   // INCO Terms Location
          //   incoTermsLocation: headerData?.incoTermsLocation || "",

          //   // Currency
          //   rfxCurrency: headerData?.currency || "",
          //   rfxCurrencyCode: headerData?.currencyCode || "",
          // }));

          // if (!draftDataRef.current) {
          if (rfqCreation === "PR" || !draftDataRef.current) {
            setFormInputs((prev) => ({
              ...prev,
              paymentTerms: headerData?.paymentTerms || "",
              paymentTermsCode: headerData?.paymentTerms || "",
              INCOTerms: headerData?.incoTerms || "",
              incoTerms: headerData?.incoTerms || [], // keep as array fallback
              INCOTermsCode: headerData?.incoTermsCode || "",
              incoTermsLocation: headerData?.incoTermsLocation || "",
              rfxCurrency: headerData?.currency || "",
              rfxCurrencyCode: headerData?.currencyCode || "",
              rfxValue:
                headerData?.purchasingReqDocumentValue || prev.rfxValue || "",
              deliveryAddressCodeDesc:
                headerData?.deliveryAddress ||
                headerData?.deliveryAddressDesc ||
                "",
              deliveryAddress:
                headerData?.deliveryAddress ||
                headerData?.deliveryAddressDesc ||
                "",
            }));
          } else {
            // If draft exists, keep draft values – do nothing
            console.log(
              "Draft exists, skipping PR header override for incoTerms.",
            );
          }
        }
      });
    }
  };
  useEffect(() => {
    if (getINCOTerms?.length > 0 && formInputs?.incoTerms) {
      const matchedIncoTerms = getINCOTerms?.filter(
        (i) => i.name === formInputs.incoTerms,
      );
      if (matchedIncoTerms?.length > 0) {
        setFormInputs((prev) => ({
          ...prev,
          INCOTerms: matchedIncoTerms,
        }));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getINCOTerms]);

  const loadTechUser = async () => {
    let obj = {
      roleId: "TECHNICAL",
    };
    await ItemService.getTechnicalUser(obj).then((item) => {
      // console.log('>> Check title ',item);
      if (item?.status === 200) {
        setTechnicalUserList(item?.data);
      } else {
        setTechnicalUserList([]);
        console.log(">> Error: Loading loadTechUser");
      }
    });
  };

  useEffect(() => {
    if (rfqCreation !== "") {
      getMasterDataFunc();
      loadLineItem();
      loadTechUser();

      if (rfqCreation === "PR") {
        localStorage.setItem("menu", "Sourcing");
        localStorage.setItem("submenu", "Purchase Requisition");
      } else {
        localStorage.setItem("menu", "Sourcing");
        localStorage.setItem("submenu", "Request for Quotation");
      }
    } else {
      window.history.back();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // Empty the dynamic questionnaire forms when entering and leaving this page
  // so a refresh or navigating away starts with empty COMM/TECH questionnaires
  useEffect(() => {
    dispatch(addDynamicFormDataCOMM([]));
    dispatch(addDynamicFormDataTECH([]));
    return () => {
      dispatch(addDynamicFormDataCOMM([]));
      dispatch(addDynamicFormDataTECH([]));
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const createDynamicformModelCOMM = () => {
    let obj = {
      formType: "COMM",
      onSave: (questions) => dispatch(addDynamicFormDataCOMM(questions)),
      onCancel: hideModalStatus,
    };
    setCreateDynamicformModelShow(true);
    setFormModalData(obj);
  };
  const createDynamicformModelTECH = () => {
    let obj = {
      formType: "TECH",
      onSave: (questions) => dispatch(addDynamicFormDataTECH(questions)),
      onCancel: hideModalStatus,
    };
    setCreateDynamicformModelShow(true);
    setFormModalData(obj);
  };

  const hideModalStatus = () => {
    setCreateDynamicformModelShow(false);
  };

  const [getLineItmeTotal, setLineItemTotal] = useState();
  //  console.log("Hhaha",getLineItmeTotal)

  // Store a questionnaire answer in formAnswers under `${formKey}-${componentId}`
  // so TECH and COMM submissions carry the values the user actually entered.
  // useCallback keeps a stable reference so passing it to the memoized
  // RenderInputField below doesn't re-render the whole questionnaire on every
  // unrelated parent render.
  const handleAnswerChange = useCallback((formKey, componentId, value) => {
    setFormAnswers((prev) => ({
      ...prev,
      [`${formKey}-${componentId}`]: value,
    }));
  }, []);

  // Handle criteria and weightage changes for dynamic form questions
  // Updates the Redux store with the new criteria/weightage values
  const handleCriteriaWeightageChange = useCallback(
    (formKey, componentId, { criteria, weightage, weightageStatus }) => {
      const action =
        formKey === "formTECH" ? "dynamicFormDataTECH" : "dynamicFormDataCOMM";
      dispatch(
        updateQuestionCriteria({
          formKey: action,
          componentId,
          criteria,
          weightage,
          weightageStatus,
        }),
      );
    },
    [dispatch],
  );

  const onInputChangeopeningDate = ({ target: { name, value } }) => {
    setOpenCloseInput((getOpenCloseInput) => ({
      ...getOpenCloseInput,
      [name]: value,
    }));
  };

  useEffect(() => {
    if (
      getOpenCloseInput.openingDate !== "" ||
      getOpenCloseInput.openingTime !== "" ||
      getOpenCloseInput.closingDate !== "" ||
      getOpenCloseInput.closingTime !== ""
    ) {
      let openDate =
        getOpenCloseInput.openingDate + " " + getOpenCloseInput.openingTime;
      let closeDate =
        getOpenCloseInput.closingDate + " " + getOpenCloseInput.closingTime;
      let res = checkTimeDifference(openDate, closeDate);
      // console.log(">> res", res);
      getOpenCloseInput.status = res.status;
      getOpenCloseInput.msg = res.msg + " '(Opening and Closing Fields)' !!";

      if (getOpenCloseInput.closingDate !== "") {
        if (res.status) {
          getOpenCloseInput.totalHour = res.totalHours;
        } else {
          toast.error(res.msg, {
            duration: 4000,
            position: "top-right",
          });
        }
      }
    }
  }, [getOpenCloseInput]);

  // Forms are now loaded from the AddFormModal via localStorage/Redux
  // The auto-loading from config has been removed - users must explicitly
  // generate or load forms using the "Generate Form" / "Modify Form" buttons

  // For Upload Success
  const onSuccessUploadDocumentType = (data) => {
    setFormInputs((formInputs) => ({
      ...formInputs,
      [data.fieldName]: data.attachmentId,
    }));
  };
  // View attachment files
  const handleViewFile = (fileAttachmentId) => {
    setFileViewData(fileAttachmentId);
    setShowFileViewModal(true);
  };
  const handleViewFileHide = () => {
    setShowFileViewModal(false);
  };
  // Open the questionnaire attachment viewer for a specific question. Stable
  // (useCallback) because it is passed into the memoized RenderInputField.
  const handleViewQuestionAttachment = useCallback(
    (formKey, componentId, attachmentId) => {
      setHBFileViewKey(`${formKey}-${componentId}-attachment`);
      setHBFileViewData(attachmentId);
      setShowHBFileViewModal(true);
    },
    [],
  );
  const handleHBFileViewHide = () => {
    setShowHBFileViewModal(false);
  };
  // When all files under a question's attachment are deleted from the viewer,
  // clear the stored attachment id so the required-attachment validation
  // re-triggers and the view icon disappears.
  const handleAttachmentDeleted = (info) => {
    if (info?.hasFiles === false && hbFileViewKey) {
      setFormAnswers((prev) => {
        const next = { ...prev };
        delete next[hbFileViewKey];
        return next;
      });
      setShowHBFileViewModal(false);
    }
  };

  // === Other Charges Handlers ===

  /* Toggle charge selection from Charges Selection checkboxes */
  const handleChargeToggle = (charge) => {
    setChargesSelected((prev) => {
      const exists = prev.find((item) => item.id === charge.id);
      if (exists) {
        return prev.filter((item) => item.id !== charge.id);
      } else {
        return [
          ...prev,
          {
            ...charge,
            documentId: charge.code,
            documentText: charge.name,
            amount: 0,
          },
        ];
      }
    });
  };
  /* Handle amount change in Other Charges table */
  // const handleChargesAmountChange = (id, value) => {
  //   if (value === "" || Number(value) > 0) {
  //     setChargesSelected((prev) =>
  //       prev.map((item) =>
  //         item.id === id ? { ...item, amount: value } : item
  //       )
  //     );
  //   }
  // };

  // Calculate total from other charges
  useEffect(() => {
    const total = getChargesSelected.reduce(
      (sum, item) => sum + (Number(item?.amount) || 0),
      0,
    );
    setOtherChargesValue(total);
  }, [getChargesSelected]);

  // Calculate subtotal from line items
  useEffect(() => {
    const items = rfqCreation === "PR" ? getLineItemData : getPRLineItemsData;
    const total = items.reduce(
      (sum, item) => sum + (Number(item?.netValue) || 0),
      0,
    );
    setSubTotalValue(total);
  }, [getLineItemData, getPRLineItemsData, rfqCreation]);

  // useEffect(() => {
  //   if (isLoadingDraft || !draftData) return;

  //   const timer = setTimeout(() => {
  //     const currentFullData = getFullFormData();
  //     if (!previousSavedStateRef.current) {
  //       previousSavedStateRef.current = JSON.parse(JSON.stringify(currentFullData));
  //       return;
  //     }
  //     if (isEqual(previousSavedStateRef.current, currentFullData)) {
  //       return;
  //     }
  //     const changedData = getChangedFields(previousSavedStateRef.current, currentFullData);
  //     if (Object.keys(changedData).length === 0) return;

  //     const updateDraft = async () => {
  //       try {
  //         const response = await ItemService.updateDraft(
  //           draftData.documentNumber,
  //           userData?.userId,
  //           draftData.draftType,
  //           changedData
  //         );
  //         if (response.status === 200) {
  //           previousSavedStateRef.current = JSON.parse(JSON.stringify(currentFullData));
  //         }
  //       } catch (error) {
  //         console.error("Failed to update draft", error);
  //       }
  //     };
  //     updateDraft();
  //   }, 2000);

  //   return () => clearTimeout(timer);
  // }, [
  //   formInputs,
  //   getLineItemData,
  //   getPRLineItemsData,
  //   getSupplierData,
  //   termsConditionsData,
  //   editorContent,
  //   dynamicFormDataCOMM,
  //   dynamicFormDataTECH,
  //   getChargesSelected,
  //   getOpenCloseInput,
  //   subTotalValue,
  //   getOtherChargesValue,
  //   isLoadingDraft,
  //   draftData,
  //   userData?.userId,
  // ]);

  const updateDraft = async (currentFullData) => {
    if (!draftDataRef.current) return;

    const newProgress = calculateDraftProgress(currentFullData);

    const changedData = getChangedFields(
      previousFullDataRef.current,
      currentFullData,
    );
    if (Object.keys(changedData).length === 0) return;

    const oldProgress = previousFullDataRef.current?.completionPercentage;
    if (oldProgress !== newProgress) {
      changedData.completionPercentage = newProgress;
    }

    if (Object.keys(changedData).length === 0) {
      console.log("No changes detected, skipping draft update.");
      return;
    }

    try {
      const response = await ItemService.updateDraft(
        draftDataRef.current.documentNumber,
        userData?.userId,
        draftDataRef.current.draftType, // "MANUAL_RFQ"
        changedData,
      );
      if (response.status === 200) {
        // Optional: update draftData with new timestamp if needed
        previousFullDataRef.current = JSON.parse(
          JSON.stringify(currentFullData),
        );
        // Also store progress in the draft data for future reference
        setDraftData((prev) => ({
          ...prev,
          completionPercentage: newProgress,
        }));
      }
    } catch (error) {
      console.error("Update draft failed:", error);
    }
  };

  useEffect(() => {
    // Skip first mount
    if (isFirstAutoSave.current) {
      isFirstAutoSave.current = false;
      previousFullDataRef.current = JSON.parse(
        JSON.stringify(getFullFormData()),
      );
      return;
    }

    // Don't run if draft is still loading or draftData is missing
    if (
      isLoadingDraft ||
      !draftDataRef.current ||
      !previousFullDataRef.current
    ) {
      return;
    }

    const currentFullData = getFullFormData();

    // Check if anything changed
    if (isEqual(previousFullDataRef.current, currentFullData)) {
      return;
    }

    const timer = setTimeout(async () => {
      try {
        await updateDraft(currentFullData);
        // Update reference after successful save
        previousFullDataRef.current = JSON.parse(
          JSON.stringify(currentFullData),
        );
      } catch (error) {
        console.error("Auto-save draft failed:", error);
      }
    }, 2000); // 2 seconds debounce

    return () => clearTimeout(timer);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    formInputs,
    getLineItemData,
    getPRLineItemsData,
    getSupplierData,
    termsConditionsData,
    editorContent,
    dynamicFormDataCOMM,
    dynamicFormDataTECH,
    getChargesSelected,
    getOpenCloseInput,
    subTotalValue,
    getOtherChargesValue,
    isLoadingDraft,
    draftData,
  ]);

  const lineItemLoadedRef = useRef(false);
  useEffect(() => {
    if (!isLoadingDraft && rfqCreation !== "" && !lineItemLoadedRef.current) {
      lineItemLoadedRef.current = true;
      loadLineItem();
    }

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isLoadingDraft, rfqCreation]);

  if (isLoadingDraft) {
    return (
      <main className="dashboard main" id="main">
        <Layout />
        {/* <div className="text-center mt-5">Loading draft...</div> */}
        <Loader isLoading={isLoadingDraft} className={"text-center"} />
      </main>
    );
  }

  // Selected RFQ type text — ComboboxField spreads the selected option, which
  // carries the display name and the rfxTypeDesc (no `description` field), so we
  // match on both. Text like "10 - Technical and Commercial" / "20 - Commercial
  // Follow-on" drives which Questionnaire blocks are shown.
  const rfqTypeText = String(
    rfqTypeSelection?.rfxTypeDesc ||
      rfqTypeSelection?.description ||
      rfqTypeSelection?.name ||
      rfqTypeSelection?.selected?.name ||
      "",
  ).toLowerCase();
  const isTechnicalRFQ = rfqTypeText.includes("technical");
  const isCommercialRFQ = rfqTypeText.includes("commercial");

  // Wizard navigation helpers. Current index is derived from the active tab so
  // Previous / Next / Create RFQ can be shown conditionally in the footer.
  const currentTabIndex = tabList.findIndex((tab) => tab.id === activeTab);
  const isLastTab = currentTabIndex === tabList.length - 1;
  const goToPreviousTab = () => {
    if (currentTabIndex > 0) setActiveTab(tabList[currentTabIndex - 1].id);
  };
  const goToNextTab = () => {
    if (currentTabIndex < tabList.length - 1)
      setActiveTab(tabList[currentTabIndex + 1].id);
  };

  return (
    <main className="dashboard main" id="main">
      <Layout />
      <Row className="justify-center subContent">
        <Col xs={12} md={12} className="rightSide">
          <div className="rightSideInner PageCommonCSS">
            <h2 className="mainTitle">Create {rfqCreation} RFQ</h2>
            <p className="subText">Fill RFQ Details</p>
            <hr />

            <div className="card">
              <div className="card-body">
                <ul className="nav nav-tabs" id="myTab" role="tablist">
                  {tabList.map((tab) => {
                    const hasError = tabErrors[tab.id];
                    const isActive = activeTab === tab.id;
                    return (
                      <li className="nav-item" role="presentation" key={tab.id}>
                        <button
                          className={`nav-link ${isActive ? "active" : ""}`}
                          id={`${tab.id}-tab`}
                          type="button"
                          role="tab"
                          aria-controls={tab.id}
                          aria-selected={isActive ? "true" : "false"}
                          onClick={() => setActiveTab(tab.id)}
                          style={hasError ? { color: "#dc3545" } : undefined}
                        >
                          {tab.label}
                          {hasError && (
                            <i
                              className="bi bi-exclamation-circle-fill"
                              style={{ marginLeft: "4px" }}
                            ></i>
                          )}
                        </button>
                      </li>
                    );
                  })}
                </ul>
                {/* title realated blocks */}
                <div className="tab-content pt-2" id="myTabContent">
                  <div
                    className={`tab-pane fade ${
                      activeTab === "rqf-titlle" ? "show active" : ""
                    }`}
                    id="rqf-titlle"
                    role="tabpanel"
                    aria-labelledby="rqf-titlle-tab"
                  >
                    {/* 02 */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible2
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility2}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">RH</span>
                            </Col>
                            <Col xs={8} md={9} lg={9}>
                              <span className="headerTitle">RFQ Header</span>
                              <span className="subHeaderTitle">
                                Header Description
                              </span>
                            </Col>
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible2 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Title"
                                  name="rfxTitle"
                                  id="rfxTitle"
                                  placeholder=""
                                  value={formInputs.rfxTitle || ""}
                                  onChange={onInputChange}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Description"
                                  name="rfxDescription"
                                  id="rfxDescription"
                                  placeholder=""
                                  value={formInputs.rfxDescription || ""}
                                  onChange={onInputChange}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Buyer Responsible"
                                  name="initiator"
                                  placeholder=""
                                  value={formInputs.initiator || ""}
                                  onChange={onInputChange}
                                  disabled={true}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Create / Initiator"
                                  name="initiator"
                                  placeholder=""
                                  value={formInputs.initiator || ""}
                                  onChange={onInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Plant"
                                  placeholder=""
                                  data={getPlant}
                                  id="plant"
                                  iconClassName="dropdownIcon"
                                  name="plant"
                                  code="plantCode"
                                  description="plantDesc"
                                  setValue={formInputs?.plant || ""}
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Company Address"
                                  placeholder=""
                                  data={getCompanyAddress}
                                  id="companyAddress"
                                  iconClassName="dropdownIcon"
                                  name="companyAddress"
                                  code="companyAddressCode"
                                  description="companyAddressDesc"
                                  setValue={formInputs.companyAddress || ""}
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="RFQ Version"
                                  name="rfxVersion"
                                  id="rfxVersion"
                                  placeholder=""
                                  value={formInputs.rfxVersion || ""}
                                  onChange={onInputChange}
                                  // disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Buyer Email"
                                  name="buyerEmail"
                                  id="buyerEmail"
                                  placeholder=""
                                  value={formInputs.buyerEmail || ""}
                                  // onChange={onInputChange}
                                  disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Billing Address"
                                  placeholder=""
                                  data={getBillingAddress}
                                  id="billingAddress"
                                  iconClassName="dropdownIcon"
                                  name="billingAddress"
                                  code="billingAddressCode"
                                  description="billingAddressDesc"
                                  setValue={formInputs.billingAddress || ""}
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Created On"
                                  name="createdOn"
                                  id="createdOn"
                                  placeholder=""
                                  value={formInputs.createdOn || ""}
                                  onChange={onInputChange}
                                  type="date"
                                  // disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Buyer Contact"
                                  name="buyerConact"
                                  id="buyerConact"
                                  placeholder=""
                                  value={formInputs.buyerConact || ""}
                                  onChange={onInputChange}
                                  // disabled={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Delivery Address"
                                  placeholder=""
                                  data={getDeliveryAddressOptions}
                                  id="deliveryAddressCodeDesc"
                                  iconClassName="dropdownIcon"
                                  name="deliveryAddressCodeDesc"
                                  setValue={
                                    formInputs.deliveryAddressCodeDesc || ""
                                  }
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="RFQ Category"
                                  name="rfxCategory"
                                  id="rfxCategory"
                                  placeholder=""
                                  value={formInputs.rfxCategoryType}
                                  disabled={true}
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* --- */}
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "configuration" ? "show active" : ""
                    }`}
                    id="configuration"
                    role="tabpanel"
                    aria-labelledby="configuration-tab"
                  >
                    {/* 01 */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">RT</span>
                            </Col>
                            <Col xs={8} md={9} lg={9}>
                              <span className="headerTitle">RFQ Type</span>
                              <span className="subHeaderTitle">
                                Basic Information
                              </span>
                            </Col>
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="RFQ Type"
                                  placeholder=""
                                  data={getRFxType}
                                  id="rfxType"
                                  iconClassName="dropdownIcon"
                                  name="rfxType"
                                  code="rfxTypeCode"
                                  description="rfxTypeDesc"
                                  setValue={formInputs.rfxType || ""}
                                  getvalue={handleRfqTypeChange}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Product Type"
                                  placeholder=""
                                  data={getRFxProductType}
                                  id="productType"
                                  iconClassName="dropdownIcon"
                                  name="productType"
                                  code="productTypeCode"
                                  description="productTypeDesc"
                                  setValue={formInputs.productType || ""}
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Estimated RFQ Value"
                                  id="rfxValue"
                                  name="rfxValue"
                                  placeholder=""
                                  // type="checkbox"
                                  value={formInputs.rfxValue || ""}
                                  onChange={onInputChange}
                                  required={true}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Bid Type"
                                  placeholder=""
                                  data={getRfxBidType}
                                  id="rfxbidType"
                                  iconClassName="dropdownIcon"
                                  name="rfxbidType"
                                  code="rfxbidTypeCode"
                                  description="rfxbidTypeDesc"
                                  setValue={formInputs.rfxbidType || ""}
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Number Of Evaluation"
                                  placeholder=""
                                  data={getRfxNoOfEvaluationType}
                                  id="rfxNoOfEvaluationType"
                                  iconClassName="dropdownIcon"
                                  name="rfxNoOfEvaluationType"
                                  code="rfxNoOfEvaluationTypeCode"
                                  description="rfxNoOfEvaluationTypeDesc"
                                  setValue={
                                    formInputs.rfxNoOfEvaluationType || ""
                                  }
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Currency"
                                  placeholder=""
                                  data={getcurrency}
                                  id="rfxCurrency"
                                  iconClassName="dropdownIcon"
                                  name="rfxCurrency"
                                  code="rfxCurrencyCode"
                                  description="rfxCurrencyDesc"
                                  setValue={formInputs.rfxCurrency || ""}
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Tech Focal Point *"
                                  placeholder=""
                                  data={getTechnicalUserList}
                                  id="rfxTechFocalPersonId"
                                  iconClassName="dropdownIcon"
                                  name="rfxTechFocalPersonId"
                                  code="rfxTechFocalPersonIdCode"
                                  description="rfxTechFocalPersonIdDesc"
                                  setValue={
                                    formInputs.rfxTechFocalPersonId || ""
                                  }
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Technical Approval Type"
                                  placeholder=""
                                  data={getTechnicalApprovalType}
                                  id="technicalApprovalType"
                                  iconClassName="dropdownIcon"
                                  name="technicalApprovalType"
                                  code="technicalApprovalTypeCode"
                                  description="technicalApprovalTypeDesc"
                                  setValue={
                                    formInputs.technicalApprovalType || ""
                                  }
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>
                              {isCommercialRFQ && (
                                <>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Commercial Total Weightage Value"
                                      id="commercialTotalWeigtage"
                                      name="commercialTotalWeigtage"
                                      placeholder=""
                                      type="number"
                                      value={
                                        formInputs.commercialTotalWeigtage ?? ""
                                      }
                                      onChange={onWeightageSplitChange}
                                      required={false}
                                      error={
                                        isTechnicalRFQ &&
                                        (Number(
                                          formInputs.commercialTotalWeigtage,
                                        ) > 0 ||
                                          Number(
                                            formInputs.technicalTotalWeight,
                                          ) > 0) &&
                                        Number(
                                          formInputs.commercialTotalWeigtage ||
                                            0,
                                        ) +
                                          Number(
                                            formInputs.technicalTotalWeight ||
                                              0,
                                          ) !==
                                          100
                                          ? "Commercial + Technical must add up to 100."
                                          : ""
                                      }
                                    />
                                  </Col>
                                </>
                              )}
                              {isTechnicalRFQ && (
                                <>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Technical Total weightage Value"
                                      id="technicalTotalWeight"
                                      name="technicalTotalWeight"
                                      placeholder=""
                                      type="number"
                                      value={
                                        formInputs?.technicalTotalWeight ?? ""
                                      }
                                      onChange={onWeightageSplitChange}
                                      required={false}
                                      error={
                                        isCommercialRFQ &&
                                        (Number(
                                          formInputs.commercialTotalWeigtage,
                                        ) > 0 ||
                                          Number(
                                            formInputs.technicalTotalWeight,
                                          ) > 0) &&
                                        Number(
                                          formInputs.commercialTotalWeigtage ||
                                            0,
                                        ) +
                                          Number(
                                            formInputs.technicalTotalWeight ||
                                              0,
                                          ) !==
                                          100
                                          ? "Commercial + Technical must add up to 100."
                                          : ""
                                      }
                                    />
                                  </Col>
                                  <Col
                                    xs={12}
                                    md={4}
                                    lg={4}
                                    className="commTopButtonRightLeftPadding"
                                  >
                                    <InputField
                                      className="inputBox"
                                      label="Minimum Technical Total weightage Value"
                                      id="minimumTechnicalTotalWeight"
                                      name="minimumTechnicalTotalWeight"
                                      placeholder=""
                                      type="number"
                                      value={
                                        formInputs.minimumTechnicalTotalWeight ||
                                        ""
                                      }
                                      onChange={onMinTechWeightChange}
                                      required={false}
                                      error={
                                        Number(
                                          formInputs.minimumTechnicalTotalWeight,
                                        ) > 100
                                          ? "Must be between 1 and 100."
                                          : ""
                                      }
                                    />
                                  </Col>
                                </>
                              )}
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* Instructions 10*/}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible10
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility10}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">RE</span>
                            </Col>
                            <Col xs={8} md={9} lg={9}>
                              <span className="headerTitle">Instructions</span>
                              <span className="subHeaderTitle">
                                Instructions Section
                              </span>
                            </Col>
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible10 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row className="p-4">
                              <Col xs={12} md={12} lg={12}>
                                <RichTextEditor
                                  value={editorContent}
                                  onChange={handleEditorChange}
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Documents Form */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible5
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility5}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">TD</span>
                            </Col>
                            <Col xs={8} md={9} lg={9}>
                              <span className="headerTitle">Documents</span>
                              <span className="subHeaderTitle">
                                Documents Form
                              </span>
                            </Col>

                            {/* <Col xs={2} md={1} lg={1} className="">
                                  <SourcingCommonFilter />
                                </Col> */}
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible5 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <h5 className="card-title">
                                {" "}
                                Terms & Conditions
                              </h5>
                              <Row>
                                <Col
                                  xs={12}
                                  md={12}
                                  lg={8}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {termsConditionsData.map((item, i) => (
                                    <div className="form-check" key={item.id}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`gridCheck${item.id}`}
                                        checked={item.status}
                                        onChange={() =>
                                          handleTermsConditionCheckBox(item.id)
                                        }
                                        disabled={item?.disabled}
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`gridCheck${item.id}`}
                                      >
                                        {item.name}
                                      </label>
                                    </div>
                                  ))}
                                </Col>
                              </Row>
                              <h1 className="card-title">Documents :</h1>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <FileUploadComponent
                                  id="scopeOfwork"
                                  name="scopeOfwork"
                                  label="1.1. SCOPE OF WORK"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={onSuccessUploadDocumentType}
                                  value={formInputs?.scopeOfwork || ""}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={1}
                                lg={1}
                                className="commTopButtonRightLeftPadding d-flex align-items-center"
                              >
                                {(formInputs?.scopeOfwork && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(formInputs?.scopeOfwork)
                                    }
                                  />
                                )) ||
                                  "--"}
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <FileUploadComponent
                                  id="drawing"
                                  name="drawing"
                                  label="1.2. DRAWING"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={onSuccessUploadDocumentType}
                                  value={formInputs?.drawing || ""}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={1}
                                lg={1}
                                className="commTopButtonRightLeftPadding d-flex align-items-center"
                              >
                                {(formInputs?.drawing && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(formInputs?.drawing)
                                    }
                                  />
                                )) ||
                                  "--"}
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <FileUploadComponent
                                  id="annexures"
                                  name="annexures"
                                  label="1.3. ANNEXURES"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={onSuccessUploadDocumentType}
                                  value={formInputs?.annexures || ""}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={1}
                                lg={1}
                                className="commTopButtonRightLeftPadding d-flex align-items-center"
                              >
                                {(formInputs?.annexures && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(formInputs?.annexures)
                                    }
                                  />
                                )) ||
                                  "--"}
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <FileUploadComponent
                                  id="others"
                                  name="others"
                                  label="1.4. OTHERS"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={onSuccessUploadDocumentType}
                                  value={formInputs?.others || ""}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={1}
                                lg={1}
                                className="commTopButtonRightLeftPadding d-flex align-items-center"
                              >
                                {(formInputs?.others && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(formInputs?.others)
                                    }
                                  />
                                )) ||
                                  "--"}
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Charges Selection */}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisibleCS
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibilityCS}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">CS</span>
                            </Col>
                            <Col xs={8} md={9} lg={9}>
                              <span className="headerTitle">
                                Charges Selection
                              </span>
                              <span className="subHeaderTitle">
                                Charges Selection
                              </span>
                            </Col>
                          </Row>
                        </h2>
                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisibleCS ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <h5 className="card-title commTopButtonRightLeftPadding">
                                Select Charges
                              </h5>
                              <Row>
                                <Col
                                  xs={12}
                                  md={12}
                                  lg={8}
                                  className="commTopButtonRightLeftPadding"
                                >
                                  {getChargesSelcetion.map((charge) => (
                                    <div className="form-check" key={charge.id}>
                                      <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id={`charge-${charge.id}`}
                                        checked={getChargesSelected.some(
                                          (item) => item.id === charge.id,
                                        )}
                                        onChange={() =>
                                          handleChargeToggle(charge)
                                        }
                                      />
                                      <label
                                        className="form-check-label"
                                        htmlFor={`charge-${charge.id}`}
                                      >
                                        {charge.name}
                                      </label>
                                    </div>
                                  ))}
                                </Col>
                              </Row>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                    {/* ---- */}
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "addItems" ? "show active" : ""
                    }`}
                    id="addItems"
                    role="tabpanel"
                    aria-labelledby="addItems-tab"
                  >
                    {/* Line Items 06*/}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible6
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility6}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">LI</span>
                            </Col>
                            <Col xs={8} md={4} lg={4}>
                              <span className="headerTitle">Line Items</span>
                              <span className="subHeaderTitle">
                                Material/ Service Details
                              </span>
                            </Col>

                            <Col
                              xs={12}
                              md={6}
                              lg={6}
                              className="headerButtonAlign"
                            >
                              <Col xs={4} md={3} lg={3} className="">
                                <button className="btnTable">
                                  Download Template
                                </button>
                              </Col>
                              <Col xs={4} md={2} lg={2} className="">
                                <button
                                  className="btnTable"
                                  onClick={() => {
                                    alert("asd");
                                  }}
                                >
                                  Upload Date
                                </button>
                              </Col>
                              <Col xs={4} md={2} lg={2} className="">
                                <button
                                  className="btnTable"
                                  onClick={addPOItemRow}
                                >
                                  Add PR Items
                                </button>
                              </Col>
                            </Col>
                            {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                          </Row>
                        </h2>
                        <div
                          // id="acc"
                          className={`accordion-collapse collapse show ${
                            isCardVisible6 ? "visible" : ""
                          }`}
                          // aria-labelledby="headingOne"
                          // data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <DataTable
                                  // title=""
                                  columns={PRLineItemInitialCol}
                                  data={
                                    formInputs?.rfqCreation === "PR"
                                      ? getLineItemData
                                      : getPRLineItemsData
                                  }
                                  // columns={lineItemsColumns}
                                  // data={lineItemsData}
                                  // progressPending={loading}
                                  paginationRowsPerPageOptions={
                                    Constants.ROW_PER_PAGE
                                  }
                                  pagination
                                  // paginationServer
                                  paginationTotalRows={getLineItmeTotal}
                                  // onChangeRowsPerPage={handlePerRowsChange}
                                  // onChangePage={handlePageChange}
                                  selectableRows
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane fade"
                    id="contact"
                    role="tabpanel"
                    aria-labelledby="contact-tab"
                  >
                    contact 2 Saepe animi et soluta ad odit soluta sunt. Nihil
                    quos omnis animi debitis cumque. Accusantium quibusdam
                    perspiciatis qui qui omnis magnam. Officiis accusamus
                    impedit molestias nostrum veniam. Qui amet ipsum iure.
                    Dignissimos fuga tempore dolor.
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "technicalCommercial" ? "show active" : ""
                    }`}
                    id="technicalCommercial"
                    role="tabpanel"
                    aria-labelledby="technicalCommercial-tab"
                  >
                    {/* COMM Form - Commercial or Technical and Commercial  */}
                    {isCommercialRFQ && (
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${
                                    isCardVisible8
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                  }`}
                                  onClick={toggleCardVisibility8}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">OC</span>
                              </Col>
                              <Col xs={8} md={6} lg={6}>
                                <span className="headerTitle">
                                  Form: COMMERCIAL - Questionnaire
                                </span>
                                <span className="subHeaderTitle">
                                  Total Weightage: {commercialWeightSum} /{" "}
                                  {defaultCommercialTotalWeigtage}
                                </span>
                              </Col>
                              <Col
                                xs={12}
                                md={5}
                                lg={5}
                                className="headerButtonAlign"
                              >
                                <Col xs={6} md={4} lg={4} className="">
                                  <button
                                    className="btnTable"
                                    onClick={createDynamicformModelCOMM}
                                  >
                                    <i className="bi bi-plus-lg"></i>{" "}
                                    {dynamicFormDataCOMM.length > 0
                                      ? "Modify Form"
                                      : "Generate Form"}
                                  </button>
                                </Col>
                              </Col>
                            </Row>
                          </h2>
                          <div
                            className={`accordion-collapse collapse show ${isCardVisible8 ? "visible" : ""}`}
                          >
                            <div className="accordion-body">
                              <Row className="commTopButtonRightLeftPadding">
                                {dynamicFormDataCOMM.length > 0 &&
                                  dynamicFormDataCOMM.map(
                                    (formJsonData, index) => (
                                      <RenderInputField
                                        questionData={formJsonData}
                                        key={index}
                                        formKey="formCOMM"
                                        formAnswers={formAnswers}
                                        onChangeAnswer={handleAnswerChange}
                                        onChangeCriteriaWeightage={
                                          handleCriteriaWeightageChange
                                        }
                                        onViewAttachment={
                                          handleViewQuestionAttachment
                                        }
                                        weightageCap={
                                          defaultCommercialTotalWeigtage
                                        }
                                        otherWeightageTotal={
                                          commercialWeightSum -
                                          (Number(formJsonData?.weightage) || 0)
                                        }
                                      />
                                    ),
                                  )}
                                {dynamicFormDataCOMM.length === 0 && (
                                  <p className="text-center mt-4">
                                    Please Generate Form !!
                                  </p>
                                )}
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}

                    {/* TECH Form - Technical or Technical and Commercial  */}
                    {isTechnicalRFQ && (
                      <div className="accordion mb-4" id="accordionExample">
                        <div className="accordion-item">
                          <h2 className="accordion-header">
                            <Row className="accordion-button">
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-left arrowBtn"
                              >
                                <i
                                  className={`bi ${
                                    isCardVisible9
                                      ? "bi-chevron-right"
                                      : "bi-chevron-down"
                                  }`}
                                  onClick={toggleCardVisibility9}
                                ></i>
                              </Col>
                              <Col
                                xs={1}
                                md={1}
                                lg={1}
                                className="text-center logoBtn"
                              >
                                <span className="iconLogo">TS</span>
                              </Col>
                              <Col xs={8} md={6} lg={6}>
                                <span className="headerTitle">
                                  Form : TECHNICAL - Questionnaire
                                </span>
                                <span className="subHeaderTitle">
                                  Total Weightage: {technicalWeightSum} /{" "}
                                  {defaultTechnicalTotalWeight}
                                </span>
                              </Col>
                              <Col
                                xs={12}
                                md={5}
                                lg={5}
                                className="headerButtonAlign"
                              >
                                <Col xs={6} md={4} lg={4} className="">
                                  <button
                                    className="btnTable"
                                    onClick={createDynamicformModelTECH}
                                  >
                                    <i className="bi bi-plus-lg"></i>{" "}
                                    {dynamicFormDataTECH.length > 0
                                      ? "Modify Form"
                                      : "Generate Form"}
                                  </button>
                                </Col>
                              </Col>
                            </Row>
                          </h2>
                          <div
                            className={`accordion-collapse collapse show ${isCardVisible9 ? "visible" : ""}`}
                          >
                            <div className="accordion-body">
                              <Row className="commTopButtonRightLeftPadding">
                                {dynamicFormDataTECH.length > 0 &&
                                  dynamicFormDataTECH.map(
                                    (formJsonData, index) => (
                                      <RenderInputField
                                        questionData={formJsonData}
                                        key={index}
                                        formKey="formTECH"
                                        formAnswers={formAnswers}
                                        onChangeAnswer={handleAnswerChange}
                                        onChangeCriteriaWeightage={
                                          handleCriteriaWeightageChange
                                        }
                                        onViewAttachment={
                                          handleViewQuestionAttachment
                                        }
                                        weightageCap={
                                          defaultTechnicalTotalWeight
                                        }
                                        otherWeightageTotal={
                                          technicalWeightSum -
                                          (Number(formJsonData?.weightage) || 0)
                                        }
                                      />
                                    ),
                                  )}
                                {dynamicFormDataTECH.length === 0 && (
                                  <p className="text-center mt-4">
                                    Please Generate Form !!
                                  </p>
                                )}
                              </Row>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "addSuppliers" ? "show active" : ""
                    }`}
                    id="addSuppliers"
                    role="tabpanel"
                    aria-labelledby="addSuppliers-tab"
                  >
                    {/* Suppliers 07*/}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible7
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility7}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">LI</span>
                            </Col>
                            <Col xs={8} md={4} lg={4}>
                              <span className="headerTitle">Suppliers</span>
                              <span className="subHeaderTitle">
                                Material/ Service Details
                              </span>
                            </Col>

                            <Col
                              xs={12}
                              md={8}
                              lg={8}
                              className="headerButtonAlign"
                            >
                              <Col xs={4} md={2} lg={2} className="">
                                <button
                                  className="btnTable"
                                  onClick={suppplierModalShow}
                                >
                                  Add Supplier
                                </button>
                              </Col>
                              <Col xs={5} md={3} lg={3} className="">
                                <button
                                  className="btnTable"
                                  onClick={() => {
                                    alert("asd");
                                  }}
                                >
                                  Initiate Supplier Request
                                </button>
                              </Col>
                              {/* <Col xs={2} md={1} lg={1} className="">
                      <SourcingCommonFilter />
                    </Col> */}
                            </Col>
                          </Row>
                        </h2>
                        <div
                          // id="acc"
                          className={`accordion-collapse collapse show ${
                            isCardVisible7 ? "visible" : ""
                          }`}
                          // aria-labelledby="headingOne"
                          // data-bs-parent="#accordionExample"
                        >
                          <div className="accordion-body">
                            <Row>
                              <Col xs={12} md={12} lg={12}>
                                <DataTable
                                  // title=""
                                  columns={suppliersColumns}
                                  data={getSupplierData}
                                  // progressPending={loading}
                                  // paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                                  // pagination
                                  // paginationServer
                                  // paginationTotalRows={totalRows}
                                  // onChangeRowsPerPage={handlePerRowsChange}
                                  // onChangePage={handlePageChange}
                                  selectableRows
                                />
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className={`tab-pane fade ${
                      activeTab === "schedule" ? "show active" : ""
                    }`}
                    id="schedule"
                    role="tabpanel"
                    aria-labelledby="schedule-tab"
                  >
                    {/* header info 03*/}
                    <div className="accordion mb-4" id="accordionExample">
                      <div className="accordion-item">
                        <h2 className="accordion-header">
                          <Row className="accordion-button">
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-left arrowBtn"
                            >
                              <i
                                className={`bi ${
                                  isCardVisible3
                                    ? "bi-chevron-right"
                                    : "bi-chevron-down"
                                }`}
                                onClick={toggleCardVisibility3}
                              ></i>
                            </Col>
                            <Col
                              xs={1}
                              md={1}
                              lg={1}
                              className="text-center logoBtn"
                            >
                              <span className="iconLogo">HI</span>
                            </Col>
                            <Col xs={8} md={9} lg={9}>
                              <span className="headerTitle">Header Info</span>
                              <span className="subHeaderTitle">
                                Header Information
                              </span>
                            </Col>
                          </Row>
                        </h2>

                        <div
                          className={`accordion-collapse collapse show ${
                            isCardVisible3 ? "visible" : ""
                          }`}
                        >
                          <div className="accordion-body">
                            <Row className="pt-2 pb-4">
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Opening Date"
                                  name="openingDate"
                                  id="openingDate"
                                  type="date"
                                  placeholder=""
                                  value={getOpenCloseInput.openingDate || ""}
                                  onChange={onInputChangeopeningDate}
                                  required={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Opening Time"
                                  name="openingTime"
                                  id="openingTime"
                                  type="time"
                                  placeholder=""
                                  value={getOpenCloseInput.openingTime || ""}
                                  onChange={onInputChangeopeningDate}
                                  required={true}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Closing Date"
                                  name="closingDate"
                                  id="closingDate"
                                  type="date"
                                  placeholder=""
                                  value={getOpenCloseInput.closingDate || ""}
                                  onChange={onInputChangeopeningDate}
                                  required={true}
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="Closing Time"
                                  name="closingTime"
                                  id="closingTime"
                                  type="time"
                                  placeholder=""
                                  value={getOpenCloseInput.closingTime || ""}
                                  onChange={onInputChangeopeningDate}
                                  required={true}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Type of Purchase"
                                  placeholder=""
                                  data={getRfxPurchaseType}
                                  id="typeOfPurchase"
                                  iconClassName="dropdownIcon"
                                  name="typeOfPurchase"
                                  setValue={formInputs.typeOfPurchase || ""}
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <MultiselectField
                                  label="Other Currencies"
                                  placeholder="Please select the Other Currencies"
                                  data={getcurrency}
                                  id="otherCurrencies"
                                  iconClassName="dropdownIcon"
                                  name="otherCurrencies"
                                  getvalue={setDropdownData}
                                  setValue={
                                    Array.isArray(formInputs.otherCurrencies)
                                      ? formInputs.otherCurrencies
                                      : []
                                  }
                                  className="dropdownOption"
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Payment Term"
                                  placeholder=""
                                  data={getpaymentTerm}
                                  id="paymentTerms"
                                  iconClassName="dropdownIcon"
                                  name="paymentTerms"
                                  setValue={formInputs.paymentTerms || ""}
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <MultiselectField
                                  label="INCO Terms"
                                  placeholder="Please select the INCO Terms"
                                  data={getINCOTerms}
                                  id="INCOTerms"
                                  iconClassName="dropdownIcon"
                                  name="INCOTerms"
                                  getvalue={setDropdownData}
                                  setValue={
                                    Array.isArray(formInputs.incoTerms)
                                      ? formInputs.incoTerms
                                      : []
                                  }
                                  className="dropdownOption"
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <InputField
                                  className="inputBox"
                                  label="INCO Terms Location"
                                  name="incoTermsLocation"
                                  id="incoTermsLocation"
                                  placeholder=""
                                  // setValue={formInputs.incoTermsLocation || ""}
                                  value={formInputs.incoTermsLocation || ""}
                                  onChange={onInputChange}
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <ComboboxField
                                  label="Reminder Enabled"
                                  key={formInputs.reminderEnabled}
                                  placeholder=""
                                  data={reminderDropDown}
                                  id="reminderEnabled"
                                  iconClassName="dropdownIcon"
                                  name="reminderEnabled"
                                  setValue={formInputs.reminderEnabled || ""}
                                  getvalue={setDropdownData}
                                  // className="dropdownOption"
                                />
                              </Col>

                              <Col
                                xs={12}
                                md={4}
                                lg={4}
                                className="commTopButtonRightLeftPadding"
                              >
                                <FileUploadComponent
                                  id="instructionsAttachment"
                                  name="instructionsAttachment"
                                  label="Instructions Attachment"
                                  allowedTypes={[
                                    "image/png",
                                    "image/jpeg",
                                    "application/pdf",
                                  ]}
                                  multiple={true} // Change to false for single file selection
                                  required={true}
                                  onSuccessUpload={onSuccessUploadDocumentType}
                                  value={
                                    formInputs?.instructionsAttachment || ""
                                  }
                                />
                              </Col>
                              <Col
                                xs={12}
                                md={1}
                                lg={1}
                                className="commTopButtonRightLeftPadding d-flex align-items-center"
                              >
                                {(formInputs?.instructionsAttachment && (
                                  <img
                                    src="assets/img/newIcons/attached-file.png"
                                    className="mt-1 attachmentIcon"
                                    alt="attachments"
                                    onClick={() =>
                                      handleViewFile(
                                        formInputs?.instructionsAttachment,
                                      )
                                    }
                                  />
                                )) ||
                                  "--"}
                              </Col>
                            </Row>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Documents 05 */}
            {/* <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisible5
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibility5}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">TD</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Documents</span>
                      <span className="subHeaderTitle">Documents Form</span>
                    </Col>

                  </Row>
                </h2>

                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisible5 ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row className="pt-2 pb-4">
                      <Col
                        xs={12}
                        md={12}
                        lg={12}
                        className="commTopButtonRightLeftPadding"
                      >
                        <h1 className="card-title">Documents :</h1>
                        <Row>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="1.1. SCOPE OF WORK"
                              name="scopeOfwork"
                              id="scopeOfwork"
                              placeholder=""
                              type="file"
                              value={formInputs.scopeOfwork || ""}
                              onChange={onInputChange}
                            />
                          </Col>

                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="1.2. DRAWING"
                              name="drawing"
                              id="drawing"
                              placeholder=""
                              type="file"
                              value={formInputs.drawing || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="1.3. ANNEXURES"
                              name="annexures"
                              id="annexures"
                              placeholder=""
                              type="file"
                              value={formInputs.annexures || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                          <Col
                            xs={12}
                            md={4}
                            lg={4}
                            className="commTopButtonRightLeftPadding"
                          >
                            <InputField
                              className="inputBox"
                              label="1.4. OTHERS"
                              name="others"
                              id="others"
                              placeholder=""
                              type="file"
                              value={formInputs.others || ""}
                              onChange={onInputChange}
                            />
                          </Col>
                        </Row>
                        <h5 className="card-title"> Terms & Conditions</h5>
                        <Row>
                          <Col
                            xs={12}
                            md={12}
                            lg={8}
                            className="commTopButtonRightLeftPadding"
                          >
                            {termsConditionsData.map((item, i) => (
                              <div className="form-check" key={item.id}>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  id={`gridCheck${item.id}`}
                                  checked={item.status}
                                  onChange={() =>
                                    handleTermsConditionCheckBox(item.id)
                                  }
                                  disabled={item?.disabled}
                                />
                                <label
                                  className="form-check-label"
                                  htmlFor={`gridCheck${item.id}`}
                                >
                                  {item.name}
                                </label>
                              </div>
                            ))}
                          </Col>
                       
                        </Row>
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div> */}

            {/* Other Charges table */}
            {/* <div className="accordion mb-4" id="accordionExample">
              <div className="accordion-item">
                <h2 className="accordion-header">
                  <Row className="accordion-button">
                    <Col xs={1} md={1} lg={1} className="text-left arrowBtn">
                      <i
                        className={`bi ${
                          isCardVisibleCT
                            ? "bi-chevron-right"
                            : "bi-chevron-down"
                        }`}
                        onClick={toggleCardVisibilityCT}
                      ></i>
                    </Col>
                    <Col xs={1} md={1} lg={1} className="text-center logoBtn">
                      <span className="iconLogo">OC</span>
                    </Col>
                    <Col xs={8} md={9} lg={9}>
                      <span className="headerTitle">Other Charges</span>
                      <span className="subHeaderTitle">Other Charges Table</span>
                    </Col>
                  </Row>
                </h2>
                <div
                  className={`accordion-collapse collapse show ${
                    isCardVisibleCT ? "visible" : ""
                  }`}
                >
                  <div className="accordion-body">
                    <Row>
                      <Col xs={12} md={12} lg={12}>
                        <DataTable
                          columns={[
                            {
                              name: "Code",
                              cell: (row) => (
                                <span>{row.documentId}</span>
                              ),
                              width: "10rem",
                            },
                            {
                              name: "Description",
                              cell: (row) => (
                                <span>{row.documentText}</span>
                              ),
                              width: "15rem",
                            },
                            {
                              name: "Amount",
                              cell: (row) => (
                                <InputField
                                  type="number"
                                  className="inputBox mt-1"
                                  min="0"
                                  value={row.amount || 0}
                                  onChange={(e) =>
                                    handleChargesAmountChange(row.id, e.target.value)
                                  }
                                />
                              ),
                              width: "15rem",
                            },
                          ]}
                          data={getChargesSelected}
                          paginationRowsPerPageOptions={Constants.ROW_PER_PAGE}
                          pagination
                        />
                      </Col>
                    </Row>
                  </div>
                </div>
              </div>
            </div> */}
          </div>
        </Col>
      </Row>
      <div className="pageFooter mb-4 pb-2">
        <Row className="align-items-center">
          <Col xs={12} md={3} lg={3} className="mb-2">
            {currentTabIndex > 0 && (
              <button
                type="button"
                className="btnTable"
                onClick={goToPreviousTab}
              >
                <i className="bi bi-arrow-left me-2"></i> Previous
              </button>
            )}
          </Col>
          <Col xs={12} md={3} lg={3} className="mb-2 ms-auto text-end">
            {isLastTab ? (
              <button
                type="button"
                disabled={disabled}
                className="btnTable"
                onClick={handleCreateRFQ}
              >
                <i className="bi bi-check2-circle me-2"></i> Create RFQ
              </button>
            ) : (
              <button type="button" className="btnTable" onClick={goToNextTab}>
                Next <i className="bi bi-arrow-right ms-2"></i>
              </button>
            )}
          </Col>
        </Row>
      </div>

      <CreateRFQSuppliers
        show={getSupplierModal}
        onHide={supplerMoadHide}
        selectedSuppliers={selectedSuppliers}
        onSelectedRows={handleSelectedRows}
        passDataToParent={handlePassDataToParent}
      />
      <SuccessRegisterModal
        show={getShowSuccessModal}
        onHide={() => hideSuccessModal()}
        modaldata={getModalInfo}
        aftersuccess={Constants.SOURCING_BUYER_REQUEST_FOR_QUOTATION}
      />

      <AddFormModal
        show={getCreateDynamicformModelShow}
        onHide={() => hideModalStatus()}
        modeldata={getFormModalData}
      />

      <FailureModal
        show={getShowFailureModal}
        onHide={() => hideFailureModal()}
        failuremodaldata={getFailureModal}
        requiredfields={getErrorFields}
      />

      {/* Item Text  */}
      <CommonItemLevelDatatableModal
        show={itemLevelModalShow}
        onHide={() => itemLevelHideModal()}
        columns={getItemLevelColumns}
        data={getItemLevelData}
        title={getModalTitle}
      />
      <FileViewerModal
        show={getShowFileViewModal}
        onHide={handleViewFileHide}
        fileid={getFileViewData}
      />
      <FileViewerModalForHB
        show={getShowHBFileViewModal}
        onHide={handleHBFileViewHide}
        fileid={getHBFileViewData}
        onDeleteSuccess={handleAttachmentDeleted}
      />
    </main>
  );
};

export default CreateRFQTabs;
